// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins";
}

button,
.btn {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
}

:root {
  --bs-btn-font-family: "Inter", sans-serif;
  --System-Blue: #007aff;
  --secondary-color: #898989;
  --success-color: #198754;
  --warning-color: #ffc107;
  --danger-color: #c9194a;
  --danger-color-light: #c9194a80;
  --info-color: #0dcaf0;
  --borders-color: #e3ebf8;
  --background-color: #f2f5fa;
  --button-color: #c9194a;
  --danger-light: #fff5f8;
}

.content-area {
  background-color: var(--background-color);
  overflow-x: hidden;
  /* display: flex; */
  /* justify-content: center; */
}

/* ===== Typography ===== */
.heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 1rem;
}

.sub-heading {
  font-size: 1.25rem;
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.75rem;
}

.content {
  font-size: 0.875rem;
  color: var(--secondary-color);
}

.label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--secondary-color);
  margin-bottom: 0.25rem;
}

/* Common Typography */
.back-button,
.add-user-back-button {
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 100% !important;
  letter-spacing: 0em !important;
  vertical-align: middle !important;
}

.page-heading {
  font-weight: 600 !important;
  font-size: 18px !important;
  line-height: 100% !important;
  letter-spacing: 0.06em !important;
}

.section-heading {
  font-weight: 600 !important;
  font-size: 13px !important;
  line-height: 100% !important;
  letter-spacing: 0.06em !important;
  color: var(--danger-color) !important;
}

.form-label {
  font-size: 14px !important;
  line-height: 100% !important;
  letter-spacing: 0em !important;
  color: #1e1e1e !important;
}

.form-labels {
  font-size: 14px !important;
  line-height: 100% !important;
  letter-spacing: 0em !important;
}

.form-input,
.form-control {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 100% !important;
  letter-spacing: 0em !important;
  height: 40px !important;
  color: #000000 !important;
}
.error-space {
  min-height: 22px; /* reserve space */
}
/* Placeholder color */
.form-input::placeholder,
.form-control::placeholder {
  color: #898989 !important;
}

/* Autofill styling */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  -webkit-text-fill-color: #000000 !important;
}
/* Placeholder-style class when value is empty */
.placeholder-style {
  color: #898989 !important;
}
.form-input option {
  color: #000000 !important;
}

.form-text {
  color: #000000 !important;
  height: 40px;
  font-size: 14px;
}

input[type="time"].form-control,
input[type="time"].form-text {
  line-height: normal !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

input[type="time"].form-control.is-invalid,
input[type="time"].form-text.is-invalid {
  padding-right: 0.75rem !important;
  background-image: none !important;
}

/* ===== Colors & Backgrounds ===== */
.primaryBackground {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
}

.primaryColorText,
.text-color {
  color: var(--danger-color) !important;
}

.text-dodger-blue {
  color: var(--System-Blue) !important;
}

.bg-custom-light {
  background-color: var(--background-color) !important;
}

.secondary-text {
  color: var(--secondary-color) !important;
}

/* ===== Buttons ===== */
.btn-custom-danger,
.btn-danger {
  background-color: var(--danger-color) !important;
  color: #fff !important;
}

.danger-light {
  background-color: var(--danger-light) !important;
  border: 1px solid var(--danger-color) !important;
}

.btn-outline-borders {
  border: 1px solid var(--borders-color);
  background-color: white;
  color: black;
}

.btn-outline-border {
  border-color: var(--danger-color) !important;
}

.btn-width {
  min-width: 40px;
}

.custom-radius,
.btn-custom-danger {
  border-radius: 16px !important;
}

.custom-radius-danger {
  border: 1px solid var(--danger-color) !important;
  border-radius: 16px !important;
}

/* ===== Tables ===== */
.table-row-spacing tbody tr {
  margin-bottom: 0.5rem;
  background-color: var(--borders-color) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.table-header-row,
.table-headers,
.table.custom-table thead tr th {
  background-color: var(--borders-color) !important;
}

.table-hover tbody tr:hover {
  background-color: rgba(var(--danger-color), 0.05);
}

.table-bordered {
  border-radius: 8px !important;
}

.truncate-cell {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== Borders & Boxes ===== */
.border-box {
  border: 1px solid var(--borders-color) !important;
  border-radius: 8px;
}

.border-custom {
  border-color: var(--borders-color) !important;
}

.custom-border-bottom {
  border-bottom: 1px solid var(--borders-color) !important;
}

.custom-border-end {
  border-right: 1px solid var(--borders-color) !important;
}

.divide-border {
  border-bottom: 1px solid #e9ecef !important;
}

.vertical-line {
  border-right: 1px solid var(--borders-color) !important;
  height: 100%;
}

.form-container {
  border: 1px solid var(--borders-color) !important;
  background-color: white !important;
  border-radius: 4px !important;
  padding: 16px !important;
}

.form-input-container {
  height: 40px !important;
  background-color: white !important;
  border: 1px solid #e9ecef !important;
}

/* ===== Form Elements ===== */
.custom-checkbox .form-check-input {
  border: 1px solid black;
  cursor: pointer;
}

.custom-checkbox .form-check-input:checked {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
}

.custom-checkbox .form-check-input:focus {
  box-shadow: none;
  border-color: black;
}

.custom-checkbox .form-check-input:checked:focus {
  box-shadow: none !important;
  border-color: var(--danger-color) !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

/* ===== Date Picker Styles ===== */
.selected-date {
  background-color: var(--danger-color) !important;
  color: white !important;
  border-radius: 0.3rem;
}

.in-range-date {
  background-color: #fee2e9 !important;
  border-radius: 0.3rem;
}

/* ===== Validation ===== */
.invalid-feedback {
  color: var(--danger-color) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.is-invalid {
  border-color: var(--danger-color) !important;
}

.is-invalid:focus {
  border-color: var(--danger-color) !important;
  box-shadow: 0 0 0 0.25rem rgba(201, 25, 74, 0.25) !important;
}

.invalid-feedbacks {
  color: rgba(var(--bs-danger-rgb)) !important;
  font-size: 12px !important;
  font-weight: 400 !important;
}

.chat-logo-size {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-bottom: 12px;
}

.chat-receiver-style {
  border-radius: 22px;
  min-width: 8%;
  padding: 2%;
  max-width: 70%;
  min-height: 40px;
  flex-direction: "column";
  justify-content: "center";
}

/* Tablet-specific styles */
@media (min-width: 768px) and (max-width: 1024px) {
  /* Typography adjustments for tablet */
  .heading {
    font-size: 1.35rem;
  }

  .sub-heading {
    font-size: 1.15rem;
  }

  .content {
    font-size: 0.9rem;
  }

  /* Table adjustments for tablet */
  .table-row-spacing tbody tr {
    margin-bottom: 0.75rem;
  }

  .truncate-cell {
    max-width: 150px;
  }

  /* Form adjustments for tablet */
  .form-label {
    font-size: 0.9rem !important;
  }

  .form-input {
    font-size: 0.9rem !important;
  }

  /* Button adjustments for tablet */
  .btn {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }

  /* Card adjustments for tablet */
  .card {
    margin-bottom: 1rem;
  }

  /* Custom spacing for tablet */
  .mb-tablet-3 {
    margin-bottom: 1rem;
  }

  .p-tablet-3 {
    padding: 1rem;
  }

  /* Tablet-specific fix for navbar search bar overlap */
  .navbar-search-bar .position-relative {
    max-width: 200px !important;
    width: 100% !important;
    min-width: 120px !important;
    margin-left: 0 !important;
  }
  .navbar-search-bar input[type="text"] {
    max-width: 200px !important;
    width: 100% !important;
  }
  .navbar-search-bar {
    margin-left: 16px !important;
  }
}

@media (min-width: 810px) {
  .navbar-search-bar {
    margin-left: 32px;
  }
}

/* iPad Pro specific styles */
@media (min-width: 1024px) and (max-width: 1366px) {
  .heading {
    font-size: 1.4rem;
  }

  .sub-heading {
    font-size: 1.2rem;
  }

  .content {
    font-size: 0.95rem;
  }

  .truncate-cell {
    max-width: 180px;
  }
}

/* iPad Mini (768px - 810px) */
@media only screen and (min-width: 768px) and (max-width: 810px) {
  /* Typography adjustments */
  .heading {
    font-size: 1.25rem;
  }

  .sub-heading {
    font-size: 1.1rem;
  }

  .content {
    font-size: 0.85rem;
  }

  /* Table adjustments */
  .truncate-cell {
    max-width: 120px;
  }

  /* Form adjustments */
  .form-label {
    font-size: 0.85rem !important;
  }

  .form-input {
    font-size: 0.85rem !important;
  }

  /* Button adjustments */
  .btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }

  /* Card adjustments */
  .card {
    margin-bottom: 0.75rem;
  }
}

/* iPad Air (810px - 1024px) */
@media only screen and (min-width: 811px) and (max-width: 1024px) {
  /* Typography adjustments */
  .heading {
    font-size: 1.35rem;
  }

  .sub-heading {
    font-size: 1.15rem;
  }

  .content {
    font-size: 0.9rem;
  }

  /* Table adjustments */
  .truncate-cell {
    max-width: 150px;
  }

  /* Form adjustments */
  .form-label {
    font-size: 0.9rem !important;
  }

  .form-input {
    font-size: 0.9rem !important;
  }

  /* Button adjustments */
  .btn {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}

/* iPad Pro 11" (1024px - 1194px) */
@media only screen and (min-width: 1024px) and (max-width: 1194px) {
  /* Typography adjustments */
  .heading {
    font-size: 1.4rem;
  }

  .sub-heading {
    font-size: 1.2rem;
  }

  .content {
    font-size: 0.95rem;
  }

  /* Table adjustments */
  .truncate-cell {
    max-width: 180px;
  }

  /* Form adjustments */
  .form-label {
    font-size: 0.95rem !important;
  }

  .form-input {
    font-size: 0.95rem !important;
  }
}

/* iPad Pro 12.9" (1194px - 1366px) */
@media only screen and (min-width: 1195px) and (max-width: 1366px) {
  /* Typography adjustments */
  .heading {
    font-size: 1.45rem;
  }

  .sub-heading {
    font-size: 1.25rem;
  }

  .content {
    font-size: 1rem;
  }

  /* Table adjustments */
  .truncate-cell {
    max-width: 200px;
  }

  /* Form adjustments */
  .form-label {
    font-size: 1rem !important;
  }

  .form-input {
    font-size: 1rem !important;
  }
}

/* Common iPad Optimizations */
@media only screen and (min-width: 768px) and (max-width: 1366px) {
  /* Optimize table spacing */
  .table-row-spacing tbody tr {
    margin-bottom: 0.75rem;
  }

  /* Optimize form containers */
  .form-container {
    padding: 12px !important;
  }

  /* Optimize spacing */
  .mb-tablet-3 {
    margin-bottom: 1rem;
  }

  .p-tablet-3 {
    padding: 1rem;
  }

  /* Optimize borders */
  .border-box {
    border-radius: 6px !important;
  }

  /* Optimize buttons */
  .btn-custom-danger,
  .btn-danger {
    padding: 0.5rem 1rem;
  }
}

/* Radio Button Styles */
.radio-group {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.radio-label {
  position: relative;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.radio-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.radio-label.selected {
  background-color: white;
  color: #0d6efd;
  border: 1px solid white;
}

.radio-label:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.radio-label.selected:hover {
  background-color: white;
}

/* Profile Section Headings */

.profile-section-heading {
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 100% !important;
  letter-spacing: 1% !important;
  color: var(--danger-color) !important;
  margin-bottom: 1rem !important;
}
.react-datepicker__day--highlighted-holiday {
  background-color: #ff6b6b;
  color: white;
  border-radius: 50%;
}
/* Today's date style */
.btn.today-highlight {
  background-color: transparent !important;
  color: #111314 !important;
  border-color: #0a58ca !important;
  /* font-weight: bold !important; */
}

/* Selected date style */
.btn.selected-date {
  background-color: #dc3545 !important;
  color: white !important;
  border-color: #dc3545 !important;
}

/* Disabled dates style */
.btn[disabled] {
  pointer-events: none;
}

/* Profile Image Shadow */

.profile-image-shadow {
  box-shadow: 0px 5px 25px 0px #2f80ed33 !important;
}

/* images */

.profile-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  padding: 0;
  border-radius: 2px;
}

.image-fallback {
  width: 100%;
  height: 110px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  color: #666666;
  font-weight: bold;
}

.react-datepicker-wrapper,
.react-datepicker__input-container,
.react-datepicker__input-container input {
  width: 100% !important;
}

Safari-specific
  override
  to
  hide
  native
  date
  picker
  icon
  input::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
.leave-day {
  background-color: #ffdddd !important; /* light red background */
  color: #d8000c !important; /* red text */
  border-radius: 50% !important;
}

.disabled-day {
  color: #ccc !important;
  pointer-events: none !important;
  text-decoration: line-through;
}
.react-datepicker__day--disabled {
  color: #ccc !important;
}

.custom-btn {
  padding: 10px 24px !important;
  gap: 10px !important;
  border-radius: 70px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-large {
  width: 160px !important;
  height: 40px !important;
}
.btn-larges {
  width: 175px !important;
  height: 40px !important;
  border-color: #c9194a !important;
  color: #c9194a !important;
}
.btn-medium {
  width: 140px !important;
  height: 40px !important;
}

.btn-small {
  width: 100px !important;
  height: 32px !important;
  font-size: 14px !important;
}

.custom-select {
  height: 40px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  /* border: 1px solid #E3EBF8 !important; */
  padding: 0 16px !important;
  color: #212529 !important;
}
.width-small {
  width: 140px !important;
}

.width-large {
  width: 180px !important;
}

.add-row-btn {
  border-radius: 8px;
  font-weight: 500;
  padding: 6px 16px;
  margin-top: 2px;
  margin-bottom: 0px;
  font-size: 13px;
}

.apply-to-all {
  width: 200px !important;
  border-width: 0.5px !important;
  border-style: solid;
  text-align: center;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.doctor-name-title {
  font-size: 16px !important;
  font-weight: 600 !important;
}

.doctor-info-text {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #898989 !important;
}

.custom-input-search {
  height: 40px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  padding-left: 36px !important;
  border: 1px solid #e3ebf8 !important;
}

.label-dropdown-toggle {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
}

.label-search-input {
  width: 100%;
  height: 36px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  outline: none;
  box-shadow: none;
}

.label-provider-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-top: 4px;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
}

.list-item {
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  padding: 10px 16px;
  margin: 4px 0;
}

.label-bgcolor {
  background-color: #f8f9fa !important;
}

.accordion-button:not(.collapsed) {
  color: #202020 !important;
  background-color: #fff !important;
  border: 1px solid var(--danger-color) !important;
  /* background-color: var(--danger-color) !important; */
}

.accordion-header .accordion-button:focus {
  box-shadow: var(--danger-color) 0px 0px 2px 0.04rem;
}

.p-multiselect-panel .p-multiselect-header {
  padding: 0.5rem 0.5rem;
}
.p-multiselect-items-wrapper ul {
  padding: 0;
}
.addServiceModal {
  width: 50% !important;
}

.form-check-input:checked {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  background-color: var(--danger-color-light) !important;
  color: #fff !important;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
}

.p-multiselect .p-multiselect-label {
  padding: 0.5rem 0.75rem;
}

.removeHeader table thead tr {
  /* display: none !important; */
}

.fc-toolbar-title {
  color: var(--danger-color) !important;
}

.removeHeader .fc-button-primary {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
}

.removeHeader .fc-prev-button {
  margin-right: 8px;
}

.removeHeader .fc .fc-button-primary:focus {
  box-shadow: var(--danger-color) 0px 0px 0px 0.2rem;
}

.linkText {
  color: blue;
  text-decoration: underline;
}

.danger-underline {
  color: var(--danger-color);
  text-decoration: underline;
}

input[type="checkbox"] {
  accent-color: var(--danger-color);
}

.plusMinus {
  border: 1px solid;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  text-align: center;
  cursor: pointer;
  margin-top: 4px;
}

.plusMinus:hover {
  background-color: var(--danger-color);
  color: #fff;
  border: none;
}

.p-dropdown-panel .p-dropdown-item.p-highlight {
  background-color: var(--danger-color) !important;
  color: #fff !important;
}

.p-dropdown .p-dropdown-label {
  background-color: #fff !important;
  color: #000 !important;
}
.p-dropdown .p-dropdown-label {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}
.p-dropdown .p-dropdown-label.p-placeholder {
  color: #6c757d !important;
  font-size: 0.9rem;
}

.inventory-select.form-select {
  height: 40px;
  background-color: #fff;
  border: 1px solid #E9ECEF;
  border-radius: 6px;
  color: #212529;
  font-size: 14px;
}

.inventory-select.form-select:focus {
  border-color: #C9194A;
  box-shadow: 0 0 0 0.2rem rgba(201, 25, 74, 0.15);
}

ul {
  padding: 0px;
}

.p-component {
  font-size: 14px !important;
}

.text-danger {
  color: var(--danger-color);
}

.copyItem {
  background-color: #fff;
  color: #000000;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
}

.invoiceTR td {
  text-align: center;
}

.invoiceHead {
  background-color: var(--danger-color);
  color: #fff;
  padding: 4px;
  font-weight: 500;
}

.invoiceBody {
  padding: 4px;
  word-wrap: break-word;
}

.leftRounded {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

.anchor_link {
  font-size: 14px;
  color: var(--danger-color);
  text-decoration: underline;
  margin: 0;
  cursor: pointer;
}

.profile_bg_color {
  background: #20202050;
  min-height: calc(100dvh - 66px);
}

/* Login page light-mode hero — scoped so ProfileSetup is unaffected */
.login_hero_bg {
  background: linear-gradient(135deg, #fce4ec 0%, #fafafa 50%, #ede7f6 100%);
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
  padding-top: 66px;
}

.login_hero_bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(0, 0, 0, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.025) 1px, transparent 1px);
  background-size: 56px 56px;
  pointer-events: none;
  z-index: 0;
}

.login_hero_bg > * {
  position: relative;
  z-index: 1;
}

.login_hero_bg .title_head {
  font-size: clamp(32px, 4vw, 56px);
  font-weight: 700;
  line-height: 1.1;
  color: #212121;
  padding-top: 8rem;
}

.login_hero_bg .title_head .primary-word {
  color: #c2185b;
}

.login_hero_bg .title_sub_head {
  font-size: 17px;
  font-weight: 400;
  line-height: 1.75;
  color: #424242;
  max-width: 500px;
}

.left_row {
  width: 80%;
}

/* Login hero image. On tablet/desktop the headline sits in the image's empty
   top-left area; on phones the image is hidden and the text shows as before. */
.login_hero_img {
  display: none;
}

@media (min-width: 768px) {
  .login_hero_bg .login_hero_visual {
    position: relative;
    width: min(100%, calc(100dvh - 66px - 40px));
    aspect-ratio: 1 / 1;
    container-type: inline-size;
    /* stop the flex column stretching the box taller than it is wide */
    align-self: flex-start;
  }

  .login_hero_bg .login_hero_img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    /* fade the image edges into the page background */
    -webkit-mask-image: linear-gradient(to right, transparent 0, #000 2.8%, #000 95.5%, transparent 100%),
      linear-gradient(to bottom, transparent 0, #000 3.5%, #000 92%, transparent 100%);
    -webkit-mask-composite: source-in;
    mask-image: linear-gradient(to right, transparent 0, #000 2.8%, #000 95.5%, transparent 100%),
      linear-gradient(to bottom, transparent 0, #000 3.5%, #000 92%, transparent 100%);
    mask-composite: intersect;
  }

  .login_hero_bg .login_hero_visual .title_head {
    position: absolute;
    top: 5cqw;
    left: 5.5cqw;
    width: 42cqw;
    margin: 0;
    padding-top: 0;
    font-size: 3.9cqw;
    line-height: 1.12;
  }

  .login_hero_bg .login_hero_visual .title_sub_head {
    display: none;
  }
}

/* Landscape tablets (iPad Air/Pro 11"): the 1/3 form column is narrower than
   the card's minimum width (reCAPTCHA + padding), so it spilled off screen.
   Give the form more room. */
@media (min-width: 992px) and (max-width: 1279.98px) and (orientation: landscape) {
  .row.login_hero_bg > .col-md-8 {
    flex: 0 0 58%;
    max-width: 58%;
  }

  .row.login_hero_bg > .col-md-4 {
    flex: 0 0 42%;
    max-width: 42%;
  }

  /* fit the 304px reCAPTCHA inside the card */
  .row.login_hero_bg .tab-adjust {
    width: 100% !important;
    max-width: 500px !important;
  }

  .row.login_hero_bg .tab-adjust > .p-5 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
}

/* Portrait tablets (iPad): side by side would make the image too small to
   read, so stack image over form, both centred. The higher specificity beats
   the site-wide tablet rule that widens every col-md-4 to 50%. */
@media (min-width: 768px) and (orientation: portrait) {
  .row.login_hero_bg > .col-md-8,
  .row.login_hero_bg > .col-md-4 {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .login_hero_bg .login_hero_visual {
    width: min(100%, 50dvh, 640px);
  }

  .row.login_hero_bg > .col-md-4 {
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
  }

  .row.login_hero_bg > .col-md-4 > div > .d-flex {
    justify-content: center;
    margin-right: 0 !important;
    padding-top: 8px !important;
  }

  .row.login_hero_bg .tab-adjust {
    width: min(500px, 90vw) !important;
    margin: 0 auto !important;
  }
}

.title_head {
  font-size: 4rem;
  font-weight: 600;
  color: #fff;
  padding-top: 8rem;
}

.title_sub_head {
  font-size: 1rem;
  font-weight: 400;
  color: #fff;
}

.flex_center {
  display: flex;
  justify-content: center;
}

.register_form {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 2rem 2rem 2rem 0;
}

.register_form input[type="text"],
.register_form input[type="email"] {
  width: 100%;
  padding: 0.1rem;
}

.register_label {
  font-size: 1rem;
}
@media (max-width: 767.98px) {
  .profile_bg_color {
    display: block; /* stack vertically */
    padding: 1rem; /* gap from edges */
    width: auto !important;
  }

  /* Text on top */
  .profile_bg_color > .col-md-8 {
    order: 1;
    width: 100%;
    max-width: 600px; /* limits width on mobile */
    margin: 0 auto 1.5rem auto; /* center with spacing */
    padding-left: 1rem; /* horizontal gap */
    padding-right: 1rem; /* horizontal gap */
  }

  /* Card below */
  .profile_bg_color > .col-md-4 {
    order: 2;
    width: 100%;
    max-width: 400px; /* card width */
    margin: 0 auto; /* center horizontally */
    padding-left: 3rem; /* horizontal gap */
  }

  /* Headings adjustments */
  .title_head {
    font-size: 2rem;
    padding-top: 1rem;
    text-align: center;
  }

  .title_sub_head {
    font-size: 0.9rem;
    text-align: center;
  }
}
.border-none {
  border: none !important;
}

.login_bg {
  background: #e6e4de;
  height: calc(100dvh - 66px);
  padding-top: 5%;
}

.title_bold {
  font-size: 2rem;
  font-weight: 600;
}
.mobile-primary {
  border-radius: 20px;
  color: var(--background-color) !important;
  background: var(--danger-color) !important;
}
.normal_tab {
  border-radius: 20px;
  color: #202020;
  background: #f4f4f5;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* ============================= */
/* MOBILE VIEW ONLY */
/* ============================= */

@media (max-width: 767.98px) {
  html,
  body {
    height: auto;
    overflow-y: auto;
  }

  .login_bg {
    height: auto !important;
    min-height: 100vh;
    overflow-y: auto;
  }

  .profile_bg_color {
    height: auto !important;
    min-height: 100vh;
  }
  .shadow-lg.bg-body.rounded {
    width: 95% !important;
    max-width: 380px !important;
    margin: 20px auto !important;
  }
  .background-color-red {
    display: flex;
    justify-content: center;
  }
  .background-color-red .d-flex {
    /* padding-top: 0px !important; */
  }

  .shadow-lg.bg-body.rounded {
    margin: 5px auto !important;
  }
}
/* Tablet view: between 769px and 1024px */
/* Tablet view: 769px to 1024px */
/* Tablet view: 769px to 1024px */
@media (min-width: 769px) and (max-width: 1024px) {
  .tab-adjust {
    width: 80% !important; /* make card slightly smaller than container */
    max-width: 500px !important; /* limit max width */
    margin: 0 auto !important; /* center horizontally */
    box-sizing: border-box; /* include padding in width */
  }

  .background-color-red {
    display: flex !important; /* make sure flex works */
    justify-content: center; /* center the card */
    padding-top: 10px !important; /* optional vertical spacing */
  }
}
@media (max-width: 767.98px) {
  .otp-wrapper input {
    width: 40px !important;
    height: 50px !important;
    font-size: 18px !important;
    /* margin: 0 4px !important; */
    border-radius: 8px;
    text-align: center;
  }

  .otp-wrapper > div {
    width: 100% !important;
    justify-content: center !important;
    /* gap: 6px; */
  }
}
.border_rad_16 {
  border-radius: 16px;
}
.accordion-button:not(.collapsed) {
  color: #000 !important; /* Text color */
  background-color: transparent !important; /* Keep background transparent */
  border: 1px solid #dc3545 !important; /* Your custom border */
  box-shadow: none !important; /* Remove default blue shadow */
  outline: none !important; /* Remove focus outline */
}

/* Collapsed Accordion Header */
.accordion-button.collapsed {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #dc3545 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Remove Bootstrap default focus outline when clicking */
.accordion-button:focus {
  box-shadow: none !important;
  outline: none !important;
}

/* Recharts wraps every chart (RevenueLineChart, StatusDonutChart, etc.) in
   a div[tabIndex=0] for keyboard accessibility — clicking inside it (a line
   point, a pie slice, or just the chart area) focuses that div, and the
   browser's default focus ring then renders as a black rectangle around
   the whole chart card. Suppress it the same way the accordion buttons
   above do. */
.recharts-wrapper:focus,
.recharts-wrapper *:focus,
.recharts-surface:focus {
  outline: none !important;
}

/* Today's Schedule / Upcoming Bookings row list (TodaysScheduleList.jsx) —
   a thin scrollbar so a long, scrolling list doesn't visibly lose row
   width/padding on the right compared to a short sibling list that never
   needs to scroll. */
.dash-schedule-scroll::-webkit-scrollbar {
  width: 6px;
}
.dash-schedule-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.dash-schedule-scroll::-webkit-scrollbar-thumb {
  background: #E3EBF8;
  border-radius: 999px;
}
.dash-schedule-scroll {
  scrollbar-width: thin;
  scrollbar-color: #E3EBF8 transparent;
}

.p-multiselect-panel .p-multiselect-header {
  padding: 0.5rem 0.5rem;
}
.p-multiselect-items-wrapper ul {
  padding: 0;
}
.addServiceModal {
  width: 50% !important;
}

.form-check-input:checked {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
}
/* CARD 1 – Service selection */
.service-selection-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  border: 1px solid #e6e6e6;
}

/* Section titles */
.section-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

/* Service type pills */
.service-type-pill {
  padding: 10px 18px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  font-weight: 500;
  transition: 0.2s;
}

.service-type-pill.active {
  background: #fff1f2;
  border: 1.5px solid #dc3545;
}

/* Offering row card */
.offering-row-card {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  padding: 12px 14px;
  transition: 0.2s ease;
}

.offering-row-card:hover {
  border-color: #dc3545;
}

.price-text {
  font-size: 12px;
  color: #dc3545;
}

/* CARD 2 – Service information */
.service-summary-card {
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  background: #fff;
}

.service-summary-header {
  padding: 12px 16px;
  font-weight: 600;
  border-bottom: 1px solid #e6e6e6;
  background: #fafafa;
  border-radius: 12px 12px 0 0;
}
/* ============================= */
/*  MOBILE RESPONSIVE (ONLY)  */
/* ============================= */

@media (max-width: 767.98px) {
  /* Reduce outer spacing */
  .mt-4.mb-2 {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

  /* Accordion header spacing */
  .accordion-button {
    font-size: 15px;
    padding: 12px 16px;
  }

  /* Make all bootstrap columns full width */
  .row > [class*="col-"] {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  /* Stack form sections nicely */
  .accordion-body {
    padding: 16px;
  }

  /* Customer info spacing */
  .accordion-body .row {
    row-gap: 12px;
  }

  /* Make inputs more touch friendly */
  .form-control,
  .p-dropdown,
  .PhoneInput input {
    height: 45px !important;
    font-size: 14px;
  }

  /* ============================= */
  /* SERVICE SELECTION CARD       */
  /* ============================= */

  .service-selection-card {
    padding: 16px;
    border-radius: 12px;
  }

  /* Service pills full width like image */
  .service-type-pill {
    width: 100%;
    text-align: center;
    padding: 12px;
  }

  /* Offering grid → single column */
  .offering-row-card {
    width: 100%;
  }

  .offering-row-card .btn {
    min-width: 70px;
  }

  /* Remove col-md-3 grid on mobile */
  .service-selection-card .col-md-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  /* ============================= */
  /* SERVICE SUMMARY CARD         */
  /* ============================= */

  .service-summary-card {
    margin-top: 16px;
  }

  .service-summary-card .row {
    row-gap: 14px;
  }

  /* Make date/time/status blocks stacked */
  .service-summary-card .col-md-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  /* Price section mobile refinement */
  .service-summary-card .border {
    margin-top: 15px;
    border-radius: 12px !important;
  }

  .service-summary-card .border .d-flex {
    font-size: 14px;
  }

  /* Make price input smaller */
  .service-summary-card input {
    width: 80px !important;
    height: 35px !important;
  }

  /* ============================= */
  /* Submit Button Mobile Style   */
  /* ============================= */

  .custom-btn.btn-large {
    width: 100%;
    height: 48px;
    font-size: 16px;
    border-radius: 10px;
  }

  .d-flex.justify-content-center.mb-0.gap-4 {
    padding: 0 16px 20px 16px;
  }
}
/* =============================== */
/* TABLET PORTRAIT (iPad Vertical) */
/* =============================== */
@media (min-width: 768px) and (max-width: 991px) {
  /* Keep 2-column layout instead of full stack */
  .row > [class*="col-md-4"] {
    flex: 0 0 50%;
    max-width: 50%;
  }

  /* Reduce spacing */
  .accordion-body {
    padding: 20px;
  }

  /* Service offering grid 2 columns */
  .service-selection-card .col-md-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  /* Price summary spacing */
  .service-summary-card .row {
    row-gap: 16px;
  }

  /* Slightly bigger button */
  .custom-btn.btn-large {
    height: 50px;
  }
}
/* ============================= */
/* MOBILE DASHBOARD FIX */
/* ============================= */
/* 
@media (max-width: 767.98px) {

  .responsive-dashboard {
    padding: 10px !important;
  }

  .calendar-section {
    display: none !important;
  }

  .new-appointment-section {
    width: 100% !important;
    padding: 15px !important;
    border-radius: 16px !important;
  }

  .responsive-dashboard .mb-3.d-flex.gap-3 {
    flex-direction: column !important;
    gap: 12px !important;
  }

  .label-dropdown-toggle {
    width: 100% !important;
  }

  .label-provider-dropdown {
    width: 100% !important;
    max-height: 220px !important;
    overflow-y: auto !important;
  }

  .responsive-dashboard [style*="timeSlotList"] {
    position: absolute !important;
    width: 100% !important;
    left: 0 !important;
    z-index: 999 !important;
  }

  .responsive-dashboard .time-slot-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }

  .responsive-dashboard .btn-large {
    height: 45px !important;
    font-size: 14px !important;
  }

  .appointment-sidebar-popup {
    width: 100% !important;
    right: 0 !important;
    border-radius: 20px 20px 0 0 !important;
    bottom: 0 !important;
    top: auto !important;
    height: 90vh !important;
  }

  .appointment-sidebar-overlay {
    background: rgba(0,0,0,0.4) !important;
  }

} */

/* Desktop */

/* .sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1049;
} */

/* @media (min-width: 768px) {
  .sidebar-overlay {
    display: none;
  }
}
@media (max-width: 767px) {
  .sidebar .nav-link {
    padding: 12px 16px !important;
    font-size: 15px;
  }

  .sidebar .form-labels {
    font-size: 14px;
  }
} */
.p-multiselect {
  width: 90% !important;
  min-width: 0 !important;
}

.p-multiselect-label {
  padding-right: 0 !important;
}
/* Mobile Responsive Styles */
@media (max-width: 767.98px) {
  .container-fluid {
    padding: 0;
    margin: 0;
    width: 100%;
    background-color: #f8f9fa;
  }

  .overview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    flex-wrap: wrap;
  }

  .overview-header h5 {
    font-size: 16px !important;
    margin: 0 !important;
  }

  .filter-by-section {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .filter-by-text {
    font-size: 12px !important;
  }

  .overview-tiles-row {
    margin: 0 !important;
    padding: 0 16px;
    gap: 12px !important;
  }

  .overview-tiles-row .col-6 {
    padding: 0 !important;
  }

  .overview-tiles-row .card {
    height: 100px !important;
    padding: 12px !important;
    border-radius: 8px !important;
  }

  .schedule-section {
    margin-top: 20px;
    background-color: #fff;
  }

  .schedule-title {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0 !important;
  }

  .schedule-search {
    padding: 0 16px 12px;
  }

  .schedule-search input {
    width: 100% !important;
    height: 36px !important;
    font-size: 13px !important;
    background-color: #f8f9fa;
    border: 1px solid #e3ebf8 !important;
    padding-left: 32px !important;
  }

  .date-selector-mobile {
    display: flex;
    overflow-x: auto;
    gap: 8px;
    padding: 12px 16px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }

  .date-btn {
    min-width: 50px;
    padding: 8px 6px !important;
    border-radius: 6px !important;
    border: 1px solid #e3ebf8 !important;
    background-color: #fff !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    flex-shrink: 0;
  }

  .date-btn.active {
    border: 2px solid #c9194a !important;
    background-color: #fff7f9 !important;
  }

  .appointment-card-item {
    padding: 12px 16px;
    border-bottom: 1px solid #e3ebf8;
    display: flex;
    gap: 12px;
    cursor: pointer;
  }

  .appointment-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: #e3ebf8;
  }

  .appointment-info {
    flex: 1 1;
  }

  .appointment-name {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }

  .appointment-specialty {
    margin: 0;
    font-size: 12px;
    color: #6c757d;
  }

  .appointment-time {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    margin-left: auto;
  }

  .d-lg-none {
    display: block !important;
  }
}

@media (max-width: 480px) {
  .overview-header {
    padding: 10px 12px;
  }

  .schedule-title {
    padding: 10px 12px;
    font-size: 13px;
  }

  .date-btn {
    min-width: 45px;
  }
}
/* ============================= */
/* MOBILE ONLY CHANGES */
/* ============================= */
/* @media (max-width: 767px) {

  .crew-top-section > .col-md-4 {
    width: 50%;
  }

  .crew-top-section > .col {
    width: 50%;
  }

  .crew-top-section .form-label {
    display: none !important;
  }

  .crew-top-section .add-btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }
   .crew-top-section .col-6 > div {
    width: 100%;
  }

  .crew-top-section .p-multiselect {
    width: 100% !important;
  }

} */
@media (max-width: 767.98px) {
  .mobile-filters {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  /* Force ALL children equal width */
  .mobile-filters > * {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 4px);
    max-width: calc(50% - 4px) !important;
  }

  /*  IMPORTANT FIX FOR SELECT DATE */
  .mobile-filters > div:first-child {
    width: 100%;
  }

  .mobile-filters > div:first-child .d-flex.position-relative {
    width: 100%;
  }

  .mobile-filters > div:first-child button {
    width: 100% !important;
  }

  /* PrimeReact fix */
  .mobile-filters .p-multiselect {
    width: 100% !important;
    min-width: 0 !important;
  }

  /* Clear All alignment */
  .mobile-filters .danger-underline {
    display: flex;
    align-items: center;
    height: 40px;
    margin-top: 22px;
  }
  .mobile-filters > * {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 4px);
    max-width: calc(50% - 4px) !important;
  }

  /* THIS FIXES SELECT DATE */
  .mobile-filters .position-relative {
    width: 100% !important;
  }

  .mobile-filters .position-relative .flex-column {
    width: 100% !important;
  }

  .mobile-filters button {
    width: 100% !important;
    justify-content: space-between;
  }

  /* PrimeReact fix */
  .mobile-filters .p-multiselect {
    width: 100% !important;
    min-width: 0 !important;
  }

  /* ACTION BUTTONS */
  .mobile-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .mobile-actions button {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 4px);
    max-width: calc(50% - 4px);
  }
}

.clearAll {
  color: var(--danger-color) !important;
  text-decoration: underline;
  cursor: pointer;
}

.flex-center-col {
  display: flex;
  justify-self: center;
  align-items: center;
  flex-direction: column;
}

.flex-center {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.setupBox {
  background: #fff;
  color: #000;
  border-radius: 16px;
  padding: 2rem;
}

.justify-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.align-center {
  display: flex;
  align-items: center;
  gap: 12px;
}
.eachSetup {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid #0000001f;
  border-radius: 10px;
  margin-bottom: 0.75rem;
  cursor: pointer;
}

.rightArrow {
  padding: 6px 10px;
  border-radius: 32px;
  background: var(--danger-color);
  color: #fff;
}

.completedBOX {
  background-color: #f2fff4;
}
.greenTick {
  width: 36px;
  height: 36px;
}
/* Prevent horizontal scroll in mobile */
/* @media (max-width: 767.98px) {
  html, body {
    overflow-x: hidden;
  }
} */
@media (max-width: 767.98px) {
  .modal-dialog {
    margin: 10px !important;
  }

  .modal-content {
    width: 100% !important;
  }
  .service-page-wrapper select {
    width: 100% !important;
    margin-top: 10px;
  }

  .service-page-wrapper .form-select {
    max-width: 100%;
  }
  .table-responsive {
    overflow-x: auto;
  }
  .mobile-action-buttons {
    width: 100%;
    margin-top: 10px;
  }

  .mobile-action-buttons > div {
    flex: 1 1 100%;
    text-align: center;
  }
  .service-page-wrapper {
    padding-left: 12px;
    padding-right: 12px;
  }

  /* Filter row wrap properly */
  .service-page-wrapper .d-flex {
    flex-wrap: wrap !important;
  }

  /* MultiSelect full width on mobile */
  .service-page-wrapper .p-multiselect {
    width: 100% !important;
  }
}
@media (max-width: 767.98px) {
  .filters-mobile {
    width: 100%;
  }

  /* FORCE exactly 2 items per row */
  .filters-mobile > * {
    flex: 0 0 48% !important;
    max-width: 48% !important;
  }

  .filters-mobile .p-multiselect {
    width: 100% !important;
    min-width: 0 !important;
  }

  /* Buttons full row */
  .actions-mobile {
    width: 100%;
    margin-top: 8px;
  }

  /* 2 buttons in one row */
  .actions-mobile > div {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 8px);
    text-align: center;
  }
}
@media (max-width: 767.98px) {
  .pagination-wrapper {
    /* overflow-x: auto; */
    width: 100%;
  }

  .pagination-wrapper > div {
    min-width: max-content;
  }
}
@media (max-width: 767.98px) {
  body {
    overflow-x: hidden;
  }

  .container-fluid {
    overflow-x: hidden;
  }
}
@media (max-width: 767.98px) {
  .header-mobile-fix {
    display: flex !important;
    flex-direction: column !important;
    gap: 14px;
  }

  /* Search full width */
  .header-mobile-fix > .col-md-4 {
    width: 100% !important;
    flex: 0 0 100% !important;
  }

  /* Hide Filter text */
  .header-mobile-fix .form-label {
    display: none !important;
  }

  /* Filter row */
  .header-mobile-fix > .col.d-flex {
    width: 100% !important;
    display: flex !important;
    align-items: center;
    gap: 10px;
  }

  /* Dropdown expands */
  .header-mobile-fix > .col.d-flex > div {
    flex: 1 1;
    min-width: 0;
  }

  .header-mobile-fix .p-multiselect {
    width: 100% !important;
  }

  /*  PUSH ADD BUTTON TO RIGHT */
  .header-mobile-fix > button {
    align-self: flex-end; /* THIS moves it to right */
    height: 40px;
  }
}
/* ---------------- MOBILE VIEW ONLY ---------------- */
@media (max-width: 767px) {
  .mobile-btn-row {
    flex-wrap: nowrap !important;
    gap: 6px;
  }

  .mobile-btn-row {
    flex: 1 1;
    /* padding: 6px 8px !important; */
    font-size: 12px;
    line-height: 1;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Dropdown grid: 2 per row */
  .mobile-dropdown-grid {
    flex-wrap: wrap;
    width: 100% !important;
  }

  .mobile-dropdown-grid > * {
    width: 46% !important;
  }

  .mobile-dropdown-grid > *:nth-child(odd) {
    margin-right: 4%;
  }
}

.opacityBOX {
  opacity: 0.5;
}
.opacityFull {
  opacity: 1 !important;
}

.dropdown-item:focus,
.dropdown-item:hover,
.dropdown-item:focus-visible {
  background-color: var(--danger-color) !important;
  color: #fff !important;
}

.viewBtn {
  border-radius: 16px;
  border: 1px solid var(--danger-color) !important;
}
.viewBtn .p-multiselect-label,
.viewBtn .p-multiselect-trigger {
  color: var(--danger-color);
}
.border-radius-16px {
  border-radius: 16px !important;
}
.otp-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.otp-popup-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  width: 350px;
  text-align: center;
}

.tableHeader {
  background-color: var(--borders-color) !important;
  padding: 0.4rem;
  font-weight: 700;
}

.borderX {
  border-left: 1px solid #20202050;
  border-right: 1px solid #20202050;
}

.rightClick {
  margin-left: -1.5rem;
  cursor: pointer;
}
/* Phone input field */
.react-tel-input .form-control {
  border: 1px solid #ced4da !important;
  height: 38px;
  border-radius: 6px;
}

/* Email input field */
.form-control {
  border: 1px solid #ced4da !important;
  height: 38px;
  border-radius: 6px;
}

/* Focus state for both */
.react-tel-input .form-control:focus,
.form-control:focus {
  box-shadow: none !important;
}
.consent-text {
  font-size: 12px;
  color: #6b7280; /* soft gray */
  margin-top: 16px;
  line-height: 1.5;
  width: 100%;
}

.link-text {
  color: #1d4ed8; /* your primary blue */
  cursor: pointer;
  font-weight: 500;
}

.link-text:hover {
  text-decoration: underline;
}

.setup-container {
  display: flex;
  justify-content: center;
}

.inner-setup-container {
  width: 50%; /* desktop default */
  max-width: 600px;
}

/* Mobile-specific styles */
@media (max-width: 767.98px) {
  .inner-setup-container {
    width: 100%;
    padding: 0.5rem;
  }

  .setupBox .eachSetup {
    flex-direction: row !important; /* keep number + text + tick in one row */
    align-items: center !important;
    justify-content: space-between;
    padding: 0.75rem;
    gap: 0.5rem;
  }

  .setupBox .eachSetup .flex-col {
    display: flex;
    flex-direction: column;
    gap: 0.2rem; /* title above description */
  }

  .setupBox .eachSetup img.greenTick {
    width: 32px;
    height: 32px;
  }

  .setupBox .progress-label {
    font-size: 10px;
    padding: 4px;
  }
}

.w-45 {
  width: 45%;
}
.bgWhite {
  background: #fff;
}
.calendarMessage {
  padding: 2rem;
  color: var(--danger-color);
}

.closeCalender {
  display: flex;
  justify-content: end;
  padding: 2px 8px;
  cursor: pointer;
  position: absolute;
  right: 0px;
  color: #202020;
  border: 1px solid black;
  border-radius: 16px;
}

.bookingCalender .fc-header-toolbar {
  position: absolute;
  /* top: 11rem; */
  width: 66rem;
}

.bookingCalender .fc .fc-view-harness {
  margin-top: 3rem;
  height: 80dvh;
  overflow: scroll;
}

.submitcalendar {
  display: flex;
  justify-content: end;
  margin-top: 1rem;
  cursor: pointer;
}

.fadeBtn {
  opacity: 0.5;
}
.img-preview {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.remove-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  background: red;
  color: #fff;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  line-height: 18px;
}

.calendarData {
  display: none;
}

.hoverCalendarBox:hover .calendarData {
  display: block;
}
@media (max-width: 767.98px) {
  .mobile-top-actions {
    display: flex;
    gap: 10px;
    width: 100%;
  }

  .mobile-top-actions > * {
    width: 50% !important; /* 🔥 each takes half */
  }

  /* Fix dropdown width */
  .mobile-top-actions .viewBtn,
  .mobile-top-actions .p-multiselect,
  .mobile-top-actions .dropdown,
  .mobile-top-actions .dropdown-toggle {
    width: 100% !important;
  }

  /* Prevent overflow */
  .mobile-top-actions .dropdown-toggle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (max-width: 767.98px) {
  .mobile-admin-view {
    flex-direction: column !important;
    gap: 15px;
  }

  .mobile-card {
    width: 100% !important;
  }

  .mobile-card .tableHeader {
    font-size: 14px;
    padding: 10px !important;
  }

  /* Row styling (EachRowCell improvement) */
  .mobile-card .row-cell {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }

}
@media (max-width: 767.98px) {

  .mobile-admin-view {
    flex-direction: column !important;
    gap: 15px;
  }

  .mobile-card {
    width: 100% !important;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #eee;
    overflow: hidden;
  }

  .mobile-card .tableHeader {
    font-size: 14px;
    padding: 10px !important;
    background: #f8f9fa;
  }
}
/* Mobile */
@media (max-width: 767.98px) {
  .footer-item {
    width: 48%;
    font-size: 12px;
  }
}
.company-footer {
  background: #d01c4c;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 14px 18px;
  border-radius: 8px;
  gap: 12px;
}

/*  KEY CHANGE */
.footer-item {
  flex: 1 1; /* auto take equal width */
  min-width: 200px; /* prevents too small items */
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

/* Icon circle */
.footer-icon {
  background: rgba(255, 255, 255, 0.15);
  padding: 8px;
  border-radius: 50%;
  font-size: 14px;
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.open-link-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #007aff;
}

.open-link-icon:hover {
  color: #0d6efd;
}
.btn-custom-danger {
  background-color: #dc3545;
  color: #fff;
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;

  width: auto; /*  important */
  display: inline-block; /*  important */
}
.percent-symbol {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.flexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.react-datepicker__day--selected-single {
  background-color: #216ba5 !important;
  color: white !important;
  border-radius: 50% !important;
}
.react-datepicker__day--highlighted-booking {
  background-color: #d01c4c !important;
  color: black !important;
  border-radius: 50%;
}
.p-multiselect .p-multiselect-clear-icon {
  display: none !important;
}

.p-multiselect-filter-container .p-input-icon-right {
  display: none !important;
}
.custom-multiselect-wrapper {
  position: relative;
  width: 100%;
}

/* MultiSelect main box */
.custom-multiselect {
  width: 100%;
  height: 40px;
}

/* give space for icon inside */
.custom-multiselect .p-multiselect-label {
  padding-right: 30px !important;
}

/* ✅ clear icon INSIDE field */
.clear-selected-icon {
  position: absolute;
  right: 30px; /* adjust inside field */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 14px;
  color: #888;
  z-index: 2;
}

/* ===== FILTER INPUT ===== */

.custom-filter {
  position: relative;
  padding: 5px;
}

.custom-filter input {
  width: 100%;
  height: 35px;
  padding: 0 30px 0 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  outline: none;
}

/* clear inside search */
.custom-filter .clear-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 14px;
  color: #888;
}
@media (max-width: 767.98px) {
  .react-datepicker__navigation {
    pointer-events: auto !important;
    z-index: 9999;
    width: 40px;
    height: 40px;
  }

  .react-datepicker__navigation--previous {
    left: 10px !important;
    pointer-events: auto !important;
  }

  .react-datepicker__navigation--next {
    right: 10px !important;
    pointer-events: auto !important;
  }
  .react-datepicker {
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  .react-datepicker__navigation-icon::before {
    border-width: 2px 2px 0 0 !important;
  }
}
/* ONLY MOBILE VIEW */
@media (max-width: 767.98px) {
  .mobile-crew-view .crew-card {
    background: #fff;
    border-radius: 14px;
    padding: 14px;
    margin-bottom: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }

  .mobile-crew-view .crew-title {
    font-size: 13px;
    color: #6c757d;
    margin-top: 2px;
  }

  .mobile-crew-view .job-item {
    padding: 6px 0;
    cursor: pointer;
  }

  .mobile-crew-view .slot-pill {
    background: #eef5ff;
    padding: 6px 10px;
    border-radius: 20px;
    font-size: 12px;
  }
  .mobile-crew-view .slots-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-height: 40px;
    overflow: hidden;
    transition: all 0.3s ease;
  }

  .mobile-crew-view .slots-container.expanded {
    max-height: 120px;
    overflow-y: auto;
  }

  .mobile-crew-view .more-btn {
    background: #dbeafe;
    cursor: pointer;
    font-weight: 500;
  }
  .mobile-crew-view .slot-pill.available {
    background: #eef5ff;
    color: #037fe8;
  }

  .mobile-crew-view .slot-pill.booked {
    background: #fdeaea;
    color: #e53935;
    text-decoration: line-through;
  }
  .job-category-inline {
    font-size: 11px;
    background: #eef5ff;
    color: #dc3545;
    padding: 2px 8px;
    border-radius: 12px;
    white-space: nowrap;
  }
}
.mobile-calendar-nav {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
}

.mobile-calendar-nav button {
  border: none;
  background: #f5f7fa;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 16px;
}
.p-multiselect-panel {
  z-index: 999999 !important;
}
.p-dropdown-panel {
  z-index: 999999 !important;
}
.onboarding-wrapper {
  min-height: 100vh;
  background: #f5f7fb;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
}

/* CARD */
.onboarding-card {
  width: 100%;
  max-width: 700px;
  background: #fff;
  padding: 30px;
  border-radius: 8px;
}

/* TITLE */
.title {
  font-weight: 600;
  margin-bottom: 5px;
}

.subtitle {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 20px;
}

/* OPTIONS */
.options-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* EACH OPTION */
.option-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 18px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  transition: 0.2s ease;
}

/* ACTIVE STATE (RED BORDER LIKE IMAGE) */
.option-box.active {
  border: 2px solid #dc3545;
  background: #fff5f5;
}

/* CHECKBOX */
.checkbox {
  width: 20px;
  height: 20px;
  border: 1px solid #bbb;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* CHECKED */
.checkbox.checked {
  background: #dc3545;
  color: #fff;
  border: none;
}

/* BUTTON */
.submit-btn {
  margin-top: 20px;
  padding: 6px 18px;
  font-size: 14px;
  border-radius: 20px;
}
.custom-offcanvas {
  width: 400px !important;
  margin: 20px;
  border-radius: 8px;
  height: calc(100% - 40px);
}

.custom-offcanvas .offcanvas-content {
  /* border-radius: 16px; */
  overflow: hidden;
}
.appointment-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.appointment-header {
  background: "#ccc";
  color: white;
  font-weight: 600;
  padding: 12px 16px;
  font-size: 16px;
}

.appointment-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 15px;
  background: "#ccc";
}
.appointment-body .form-control,
.appointment-body .form-select {
  border-radius: 8px;
  border: none;
  font-size: 13px;
  height: 36px;
}

/* The global ".form-control { line-height:100% !important; height:40px
   !important; }" rule above (line ~101) also matches react-phone-input-2's
   own input (it carries the "form-control" class) and squeezes its line-box
   down from the library's own line-height:25px to line-height:100% (=14px,
   since font-size is forced to 14px too) inside a taller 40px box — the
   "+91" prefix text ends up rendered outside the visible line-box and
   disappears, while the flag icon (a separate, independently-positioned
   element) is unaffected. That rule uses !important, so only another
   !important rule with equal-or-higher specificity can win here. */
.appointment-body .react-tel-input .form-control {
  height: 40px !important;
  line-height: 40px !important;
  padding-left: 48px !important;
}

.appointment-body label {
  font-size: 12px;
  margin-bottom: 4px;
  color: #000 !important;
}
.p-multiselect {
  width: 100% !important;
}
.blocked-date {
  background-color: #ffe5e5 !important;
  color: #d32f2f !important;
  border-radius: 50%;
  /* text-decoration: line-through; */
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;;EAEE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,gBAAgB,EAAE,kBAAkB;AACtC;AACA,sBAAsB;AACtB;;EAEE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;;;;EAIE,uDAAuD;EACvD,2CAA2C;AAC7C;AACA,gDAAgD;AAChD;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,qCAAqC;AACrC;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;;EAEE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kCAAkC;EAClC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,4DAA4D;AAC9D;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,sCAAsC;EACtC;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,kCAAkC;EAClC;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA,sDAAsD;EACtD;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,uBAAuB;EACvB;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,qBAAqB;EACrB;IACE,sBAAsB;EACxB;AACF;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,uBAAuB;EACvB;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA,qCAAqC;AACrC;EACE,2BAA2B;EAC3B;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B;IACE,sBAAsB;EACxB;;EAEA,6BAA6B;EAC7B;IACE,wBAAwB;EAC1B;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,6BAA6B;EAC/B;;EAEA,qBAAqB;EACrB;;IAEE,oBAAoB;EACtB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA,6BAA6B;;AAE7B;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA,uBAAuB;AACvB;EACE,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;;AAEzB;EACE,iDAAiD;AACnD;;AAEA,WAAW;;AAEX;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,oCAAoC,EAAE,yBAAyB;EAC/D,yBAAyB,EAAE,aAAa;EACxC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,sEAAsE;AACtE;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;qEACmE;EACnE,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;+EAC+E;AAC/E;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mBAAmB;IACnB,2BAA2B;IAC3B,mEAAmE;IACnE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kDAAkD;IAClD;sFACkF;IAClF,iCAAiC;IACjC;sFACkF;IAClF,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;6BAE6B;AAC7B;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,4CAA4C;EAC5C;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF;;AAEA;;iEAEiE;AACjE;EACE;;IAEE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc,EAAE,qBAAqB;IACrC,aAAa,EAAE,mBAAmB;IAClC,sBAAsB;EACxB;;EAEA,gBAAgB;EAChB;IACE,QAAQ;IACR,WAAW;IACX,gBAAgB,EAAE,2BAA2B;IAC7C,0BAA0B,EAAE,wBAAwB;IACpD,kBAAkB,EAAE,mBAAmB;IACvC,mBAAmB,EAAE,mBAAmB;EAC1C;;EAEA,eAAe;EACf;IACE,QAAQ;IACR,WAAW;IACX,gBAAgB,EAAE,eAAe;IACjC,cAAc,EAAE,wBAAwB;IACxC,kBAAkB,EAAE,mBAAmB;EACzC;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,kCAAkC;AAClC,qBAAqB;AACrB,kCAAkC;;AAElC;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA,0CAA0C;AAC1C,iCAAiC;AACjC,iCAAiC;AACjC;EACE;IACE,qBAAqB,EAAE,8CAA8C;IACrE,2BAA2B,EAAE,oBAAoB;IACjD,yBAAyB,EAAE,wBAAwB;IACnD,sBAAsB,EAAE,6BAA6B;EACvD;;EAEA;IACE,wBAAwB,EAAE,yBAAyB;IACnD,uBAAuB,EAAE,oBAAoB;IAC7C,4BAA4B,EAAE,8BAA8B;EAC9D;AACF;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,cAAc;EAChB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB,EAAE,eAAe;EACvC,wCAAwC,EAAE,gCAAgC;EAC1E,oCAAoC,EAAE,uBAAuB;EAC7D,2BAA2B,EAAE,+BAA+B;EAC5D,wBAAwB,EAAE,yBAAyB;AACrD;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,wCAAwC;EACxC,oCAAoC;EACpC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;cAKc;AACd;;;EAGE,wBAAwB;AAC1B;;AAEA;;;qBAGqB;AACrB;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;AACA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,kCAAkC;AAClC,+BAA+B;AAC/B,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA,0CAA0C;EAC1C;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA,0BAA0B;EAC1B;IACE,aAAa;EACf;;EAEA,oCAAoC;EACpC;;;IAGE,uBAAuB;IACvB,eAAe;EACjB;;EAEA,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;;EAElC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,wCAAwC;EACxC;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA,kCAAkC;EAClC;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;;EAElC;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;;EAElC;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA,oCAAoC;AACpC,oCAAoC;AACpC,oCAAoC;AACpC;EACE,+CAA+C;EAC/C;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,0BAA0B;EAC1B;IACE,aAAa;EACf;;EAEA,2BAA2B;EAC3B;IACE,YAAY;EACd;AACF;AACA,kCAAkC;AAClC,yBAAyB;AACzB,kCAAkC;AAClC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6DG;;AAEH,YAAY;;AAEZ;;;;;GAKG;;AAEH;;;;;;;;;;;;;;GAcG;AACH;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;AACA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,kCAAkC;AAClC,wBAAwB;AACxB,kCAAkC;AAClC;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;AACH;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA,mCAAmC;EACnC;IACE,YAAoC;IAApC,cAAoC;IAApC,2BAAoC;IACpC,qCAAqC;EACvC;;EAEA,mCAAmC;EACnC;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA,mBAAmB;EACnB;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAoC;IAApC,cAAoC;IAApC,2BAAoC;IACpC,qCAAqC;EACvC;;EAEA,2BAA2B;EAC3B;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,mBAAmB;EACnB;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,wCAAwC;AACxC;;;;GAIG;AACH;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,6BAA6B;EAC7B;IACE,0BAA0B;EAC5B;;EAEA,qCAAqC;EACrC;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,WAAW;EACb;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,SAAS;EACX;;EAEA,sBAAsB;EACtB;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,wBAAwB;EAC1B;;EAEA,eAAe;EACf;IACE,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,SAAS;EACX;;EAEA,qBAAqB;EACrB;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA,8BAA8B;EAC9B;IACE,oBAAoB,EAAE,2BAA2B;IACjD,YAAY;EACd;AACF;AACA,uDAAuD;AACvD;EACE;IACE,4BAA4B;IAC5B,QAAQ;EACV;;EAEA;IACE,SAAO;IACP,iCAAiC;IACjC,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;;EAEE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc,EAAE,cAAc;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU,EAAE,oBAAoB;EAChC,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,8BAA8B,EAAE,yCAAyC;IACzE,8BAA8B;IAC9B,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,4BAA4B;EAC3C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;IACb,SAAS;IACT,WAAW;EACb;;EAEA;IACE,qBAAqB,EAAE,uBAAuB;EAChD;;EAEA,uBAAuB;EACvB;;;;IAIE,sBAAsB;EACxB;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,iCAAiC;IACjC,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,6BAA6B;IAC7B,eAAe;EACjB;;AAEF;AACA;;EAEE;IACE,iCAAiC;IACjC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;EACrB;AACF;AACA,WAAW;AACX;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,SAAO,EAAE,0BAA0B;EACnC,gBAAgB,EAAE,6BAA6B;EAC/C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;;EAEf,WAAW,EAAE,eAAe;EAC5B,qBAAqB,EAAE,eAAe;AACxC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW,EAAE,wBAAwB;EACrC,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA,6BAA6B;;AAE7B;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE;IACE,+BAA+B;IAC/B,aAAa;IACb,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,+BAA+B;EACjC;EACA;IACE,0BAA0B;IAC1B,wCAAwC;EAC1C;EACA;IACE,oCAAoC;EACtC;AACF;AACA,qBAAqB;AACrB;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;;;;;;;;mEAQmE;AACnE;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap\");\n\nbody {\n  font-family: \"Poppins\";\n}\n\nbutton,\n.btn {\n  font-family: \"Inter\", sans-serif !important;\n  font-weight: 600 !important;\n}\n\n:root {\n  --bs-btn-font-family: \"Inter\", sans-serif;\n  --System-Blue: #007aff;\n  --secondary-color: #898989;\n  --success-color: #198754;\n  --warning-color: #ffc107;\n  --danger-color: #c9194a;\n  --danger-color-light: #c9194a80;\n  --info-color: #0dcaf0;\n  --borders-color: #e3ebf8;\n  --background-color: #f2f5fa;\n  --button-color: #c9194a;\n  --danger-light: #fff5f8;\n}\n\n.content-area {\n  background-color: var(--background-color);\n  overflow-x: hidden;\n  /* display: flex; */\n  /* justify-content: center; */\n}\n\n/* ===== Typography ===== */\n.heading {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 1rem;\n}\n\n.sub-heading {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #212529;\n  margin-bottom: 0.75rem;\n}\n\n.content {\n  font-size: 0.875rem;\n  color: var(--secondary-color);\n}\n\n.label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--secondary-color);\n  margin-bottom: 0.25rem;\n}\n\n/* Common Typography */\n.back-button,\n.add-user-back-button {\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 100% !important;\n  letter-spacing: 0em !important;\n  vertical-align: middle !important;\n}\n\n.page-heading {\n  font-weight: 600 !important;\n  font-size: 18px !important;\n  line-height: 100% !important;\n  letter-spacing: 0.06em !important;\n}\n\n.section-heading {\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  line-height: 100% !important;\n  letter-spacing: 0.06em !important;\n  color: var(--danger-color) !important;\n}\n\n.form-label {\n  font-size: 14px !important;\n  line-height: 100% !important;\n  letter-spacing: 0em !important;\n  color: #1e1e1e !important;\n}\n\n.form-labels {\n  font-size: 14px !important;\n  line-height: 100% !important;\n  letter-spacing: 0em !important;\n}\n\n.form-input,\n.form-control {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 100% !important;\n  letter-spacing: 0em !important;\n  height: 40px !important;\n  color: #000000 !important;\n}\n.error-space {\n  min-height: 22px; /* reserve space */\n}\n/* Placeholder color */\n.form-input::placeholder,\n.form-control::placeholder {\n  color: #898989 !important;\n}\n\n/* Autofill styling */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px white inset !important;\n  -webkit-text-fill-color: #000000 !important;\n}\n/* Placeholder-style class when value is empty */\n.placeholder-style {\n  color: #898989 !important;\n}\n.form-input option {\n  color: #000000 !important;\n}\n\n.form-text {\n  color: #000000 !important;\n  height: 40px;\n  font-size: 14px;\n}\n\ninput[type=\"time\"].form-control,\ninput[type=\"time\"].form-text {\n  line-height: normal !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\ninput[type=\"time\"].form-control.is-invalid,\ninput[type=\"time\"].form-text.is-invalid {\n  padding-right: 0.75rem !important;\n  background-image: none !important;\n}\n\n/* ===== Colors & Backgrounds ===== */\n.primaryBackground {\n  background-color: var(--danger-color) !important;\n  border-color: var(--danger-color) !important;\n}\n\n.primaryColorText,\n.text-color {\n  color: var(--danger-color) !important;\n}\n\n.text-dodger-blue {\n  color: var(--System-Blue) !important;\n}\n\n.bg-custom-light {\n  background-color: var(--background-color) !important;\n}\n\n.secondary-text {\n  color: var(--secondary-color) !important;\n}\n\n/* ===== Buttons ===== */\n.btn-custom-danger,\n.btn-danger {\n  background-color: var(--danger-color) !important;\n  color: #fff !important;\n}\n\n.danger-light {\n  background-color: var(--danger-light) !important;\n  border: 1px solid var(--danger-color) !important;\n}\n\n.btn-outline-borders {\n  border: 1px solid var(--borders-color);\n  background-color: white;\n  color: black;\n}\n\n.btn-outline-border {\n  border-color: var(--danger-color) !important;\n}\n\n.btn-width {\n  min-width: 40px;\n}\n\n.custom-radius,\n.btn-custom-danger {\n  border-radius: 16px !important;\n}\n\n.custom-radius-danger {\n  border: 1px solid var(--danger-color) !important;\n  border-radius: 16px !important;\n}\n\n/* ===== Tables ===== */\n.table-row-spacing tbody tr {\n  margin-bottom: 0.5rem;\n  background-color: var(--borders-color) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.table-header-row,\n.table-headers,\n.table.custom-table thead tr th {\n  background-color: var(--borders-color) !important;\n}\n\n.table-hover tbody tr:hover {\n  background-color: rgba(var(--danger-color), 0.05);\n}\n\n.table-bordered {\n  border-radius: 8px !important;\n}\n\n.truncate-cell {\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ===== Borders & Boxes ===== */\n.border-box {\n  border: 1px solid var(--borders-color) !important;\n  border-radius: 8px;\n}\n\n.border-custom {\n  border-color: var(--borders-color) !important;\n}\n\n.custom-border-bottom {\n  border-bottom: 1px solid var(--borders-color) !important;\n}\n\n.custom-border-end {\n  border-right: 1px solid var(--borders-color) !important;\n}\n\n.divide-border {\n  border-bottom: 1px solid #e9ecef !important;\n}\n\n.vertical-line {\n  border-right: 1px solid var(--borders-color) !important;\n  height: 100%;\n}\n\n.form-container {\n  border: 1px solid var(--borders-color) !important;\n  background-color: white !important;\n  border-radius: 4px !important;\n  padding: 16px !important;\n}\n\n.form-input-container {\n  height: 40px !important;\n  background-color: white !important;\n  border: 1px solid #e9ecef !important;\n}\n\n/* ===== Form Elements ===== */\n.custom-checkbox .form-check-input {\n  border: 1px solid black;\n  cursor: pointer;\n}\n\n.custom-checkbox .form-check-input:checked {\n  background-color: var(--danger-color) !important;\n  border-color: var(--danger-color) !important;\n}\n\n.custom-checkbox .form-check-input:focus {\n  box-shadow: none;\n  border-color: black;\n}\n\n.custom-checkbox .form-check-input:checked:focus {\n  box-shadow: none !important;\n  border-color: var(--danger-color) !important;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n/* ===== Date Picker Styles ===== */\n.selected-date {\n  background-color: var(--danger-color) !important;\n  color: white !important;\n  border-radius: 0.3rem;\n}\n\n.in-range-date {\n  background-color: #fee2e9 !important;\n  border-radius: 0.3rem;\n}\n\n/* ===== Validation ===== */\n.invalid-feedback {\n  color: var(--danger-color) !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n}\n\n.is-invalid {\n  border-color: var(--danger-color) !important;\n}\n\n.is-invalid:focus {\n  border-color: var(--danger-color) !important;\n  box-shadow: 0 0 0 0.25rem rgba(201, 25, 74, 0.25) !important;\n}\n\n.invalid-feedbacks {\n  color: rgba(var(--bs-danger-rgb)) !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n}\n\n.chat-logo-size {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  margin-bottom: 12px;\n}\n\n.chat-receiver-style {\n  border-radius: 22px;\n  min-width: 8%;\n  padding: 2%;\n  max-width: 70%;\n  min-height: 40px;\n  flex-direction: \"column\";\n  justify-content: \"center\";\n}\n\n/* Tablet-specific styles */\n@media (min-width: 768px) and (max-width: 1024px) {\n  /* Typography adjustments for tablet */\n  .heading {\n    font-size: 1.35rem;\n  }\n\n  .sub-heading {\n    font-size: 1.15rem;\n  }\n\n  .content {\n    font-size: 0.9rem;\n  }\n\n  /* Table adjustments for tablet */\n  .table-row-spacing tbody tr {\n    margin-bottom: 0.75rem;\n  }\n\n  .truncate-cell {\n    max-width: 150px;\n  }\n\n  /* Form adjustments for tablet */\n  .form-label {\n    font-size: 0.9rem !important;\n  }\n\n  .form-input {\n    font-size: 0.9rem !important;\n  }\n\n  /* Button adjustments for tablet */\n  .btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  /* Card adjustments for tablet */\n  .card {\n    margin-bottom: 1rem;\n  }\n\n  /* Custom spacing for tablet */\n  .mb-tablet-3 {\n    margin-bottom: 1rem;\n  }\n\n  .p-tablet-3 {\n    padding: 1rem;\n  }\n\n  /* Tablet-specific fix for navbar search bar overlap */\n  .navbar-search-bar .position-relative {\n    max-width: 200px !important;\n    width: 100% !important;\n    min-width: 120px !important;\n    margin-left: 0 !important;\n  }\n  .navbar-search-bar input[type=\"text\"] {\n    max-width: 200px !important;\n    width: 100% !important;\n  }\n  .navbar-search-bar {\n    margin-left: 16px !important;\n  }\n}\n\n@media (min-width: 810px) {\n  .navbar-search-bar {\n    margin-left: 32px;\n  }\n}\n\n/* iPad Pro specific styles */\n@media (min-width: 1024px) and (max-width: 1366px) {\n  .heading {\n    font-size: 1.4rem;\n  }\n\n  .sub-heading {\n    font-size: 1.2rem;\n  }\n\n  .content {\n    font-size: 0.95rem;\n  }\n\n  .truncate-cell {\n    max-width: 180px;\n  }\n}\n\n/* iPad Mini (768px - 810px) */\n@media only screen and (min-width: 768px) and (max-width: 810px) {\n  /* Typography adjustments */\n  .heading {\n    font-size: 1.25rem;\n  }\n\n  .sub-heading {\n    font-size: 1.1rem;\n  }\n\n  .content {\n    font-size: 0.85rem;\n  }\n\n  /* Table adjustments */\n  .truncate-cell {\n    max-width: 120px;\n  }\n\n  /* Form adjustments */\n  .form-label {\n    font-size: 0.85rem !important;\n  }\n\n  .form-input {\n    font-size: 0.85rem !important;\n  }\n\n  /* Button adjustments */\n  .btn {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.85rem;\n  }\n\n  /* Card adjustments */\n  .card {\n    margin-bottom: 0.75rem;\n  }\n}\n\n/* iPad Air (810px - 1024px) */\n@media only screen and (min-width: 811px) and (max-width: 1024px) {\n  /* Typography adjustments */\n  .heading {\n    font-size: 1.35rem;\n  }\n\n  .sub-heading {\n    font-size: 1.15rem;\n  }\n\n  .content {\n    font-size: 0.9rem;\n  }\n\n  /* Table adjustments */\n  .truncate-cell {\n    max-width: 150px;\n  }\n\n  /* Form adjustments */\n  .form-label {\n    font-size: 0.9rem !important;\n  }\n\n  .form-input {\n    font-size: 0.9rem !important;\n  }\n\n  /* Button adjustments */\n  .btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* iPad Pro 11\" (1024px - 1194px) */\n@media only screen and (min-width: 1024px) and (max-width: 1194px) {\n  /* Typography adjustments */\n  .heading {\n    font-size: 1.4rem;\n  }\n\n  .sub-heading {\n    font-size: 1.2rem;\n  }\n\n  .content {\n    font-size: 0.95rem;\n  }\n\n  /* Table adjustments */\n  .truncate-cell {\n    max-width: 180px;\n  }\n\n  /* Form adjustments */\n  .form-label {\n    font-size: 0.95rem !important;\n  }\n\n  .form-input {\n    font-size: 0.95rem !important;\n  }\n}\n\n/* iPad Pro 12.9\" (1194px - 1366px) */\n@media only screen and (min-width: 1195px) and (max-width: 1366px) {\n  /* Typography adjustments */\n  .heading {\n    font-size: 1.45rem;\n  }\n\n  .sub-heading {\n    font-size: 1.25rem;\n  }\n\n  .content {\n    font-size: 1rem;\n  }\n\n  /* Table adjustments */\n  .truncate-cell {\n    max-width: 200px;\n  }\n\n  /* Form adjustments */\n  .form-label {\n    font-size: 1rem !important;\n  }\n\n  .form-input {\n    font-size: 1rem !important;\n  }\n}\n\n/* Common iPad Optimizations */\n@media only screen and (min-width: 768px) and (max-width: 1366px) {\n  /* Optimize table spacing */\n  .table-row-spacing tbody tr {\n    margin-bottom: 0.75rem;\n  }\n\n  /* Optimize form containers */\n  .form-container {\n    padding: 12px !important;\n  }\n\n  /* Optimize spacing */\n  .mb-tablet-3 {\n    margin-bottom: 1rem;\n  }\n\n  .p-tablet-3 {\n    padding: 1rem;\n  }\n\n  /* Optimize borders */\n  .border-box {\n    border-radius: 6px !important;\n  }\n\n  /* Optimize buttons */\n  .btn-custom-danger,\n  .btn-danger {\n    padding: 0.5rem 1rem;\n  }\n}\n\n/* Radio Button Styles */\n.radio-group {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.radio-label {\n  position: relative;\n  padding: 8px 16px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.radio-input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.radio-label.selected {\n  background-color: white;\n  color: #0d6efd;\n  border: 1px solid white;\n}\n\n.radio-label:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.radio-label.selected:hover {\n  background-color: white;\n}\n\n/* Profile Section Headings */\n\n.profile-section-heading {\n  font-weight: 600 !important;\n  font-size: 16px !important;\n  line-height: 100% !important;\n  letter-spacing: 1% !important;\n  color: var(--danger-color) !important;\n  margin-bottom: 1rem !important;\n}\n.react-datepicker__day--highlighted-holiday {\n  background-color: #ff6b6b;\n  color: white;\n  border-radius: 50%;\n}\n/* Today's date style */\n.btn.today-highlight {\n  background-color: transparent !important;\n  color: #111314 !important;\n  border-color: #0a58ca !important;\n  /* font-weight: bold !important; */\n}\n\n/* Selected date style */\n.btn.selected-date {\n  background-color: #dc3545 !important;\n  color: white !important;\n  border-color: #dc3545 !important;\n}\n\n/* Disabled dates style */\n.btn[disabled] {\n  pointer-events: none;\n}\n\n/* Profile Image Shadow */\n\n.profile-image-shadow {\n  box-shadow: 0px 5px 25px 0px #2f80ed33 !important;\n}\n\n/* images */\n\n.profile-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  object-position: center;\n  padding: 0;\n  border-radius: 2px;\n}\n\n.image-fallback {\n  width: 100%;\n  height: 110px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 48px;\n  color: #666666;\n  font-weight: bold;\n}\n\n.react-datepicker-wrapper,\n.react-datepicker__input-container,\n.react-datepicker__input-container input {\n  width: 100% !important;\n}\n\nSafari-specific\n  override\n  to\n  hide\n  native\n  date\n  picker\n  icon\n  input::-webkit-calendar-picker-indicator {\n  display: none;\n  -webkit-appearance: none;\n}\n.leave-day {\n  background-color: #ffdddd !important; /* light red background */\n  color: #d8000c !important; /* red text */\n  border-radius: 50% !important;\n}\n\n.disabled-day {\n  color: #ccc !important;\n  pointer-events: none !important;\n  text-decoration: line-through;\n}\n.react-datepicker__day--disabled {\n  color: #ccc !important;\n}\n\n.custom-btn {\n  padding: 10px 24px !important;\n  gap: 10px !important;\n  border-radius: 70px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.btn-large {\n  width: 160px !important;\n  height: 40px !important;\n}\n.btn-larges {\n  width: 175px !important;\n  height: 40px !important;\n  border-color: #c9194a !important;\n  color: #c9194a !important;\n}\n.btn-medium {\n  width: 140px !important;\n  height: 40px !important;\n}\n\n.btn-small {\n  width: 100px !important;\n  height: 32px !important;\n  font-size: 14px !important;\n}\n\n.custom-select {\n  height: 40px !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  /* border: 1px solid #E3EBF8 !important; */\n  padding: 0 16px !important;\n  color: #212529 !important;\n}\n.width-small {\n  width: 140px !important;\n}\n\n.width-large {\n  width: 180px !important;\n}\n\n.add-row-btn {\n  border-radius: 8px;\n  font-weight: 500;\n  padding: 6px 16px;\n  margin-top: 2px;\n  margin-bottom: 0px;\n  font-size: 13px;\n}\n\n.apply-to-all {\n  width: 200px !important;\n  border-width: 0.5px !important;\n  border-style: solid;\n  text-align: center;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.doctor-name-title {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n}\n\n.doctor-info-text {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  color: #898989 !important;\n}\n\n.custom-input-search {\n  height: 40px !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  padding-left: 36px !important;\n  border: 1px solid #e3ebf8 !important;\n}\n\n.label-dropdown-toggle {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  padding: 8px 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 40px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n}\n\n.label-search-input {\n  width: 100%;\n  height: 36px;\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: none;\n}\n\n.label-provider-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: white;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  margin-top: 4px;\n  z-index: 1000;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.list-item {\n  border-bottom: 1px solid #e9ecef;\n  cursor: pointer;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n  padding: 10px 16px;\n  margin: 4px 0;\n}\n\n.label-bgcolor {\n  background-color: #f8f9fa !important;\n}\n\n.accordion-button:not(.collapsed) {\n  color: #202020 !important;\n  background-color: #fff !important;\n  border: 1px solid var(--danger-color) !important;\n  /* background-color: var(--danger-color) !important; */\n}\n\n.accordion-header .accordion-button:focus {\n  box-shadow: var(--danger-color) 0px 0px 2px 0.04rem;\n}\n\n.p-multiselect-panel .p-multiselect-header {\n  padding: 0.5rem 0.5rem;\n}\n.p-multiselect-items-wrapper ul {\n  padding: 0;\n}\n.addServiceModal {\n  width: 50% !important;\n}\n\n.form-check-input:checked {\n  background-color: var(--danger-color) !important;\n  border-color: var(--danger-color) !important;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n  background-color: var(--danger-color-light) !important;\n  color: #fff !important;\n}\n\n.p-checkbox.p-highlight .p-checkbox-box {\n  background-color: var(--danger-color) !important;\n  border-color: var(--danger-color) !important;\n}\n\n.p-multiselect .p-multiselect-label {\n  padding: 0.5rem 0.75rem;\n}\n\n.removeHeader table thead tr {\n  /* display: none !important; */\n}\n\n.fc-toolbar-title {\n  color: var(--danger-color) !important;\n}\n\n.removeHeader .fc-button-primary {\n  background-color: var(--danger-color) !important;\n  border-color: var(--danger-color) !important;\n}\n\n.removeHeader .fc-prev-button {\n  margin-right: 8px;\n}\n\n.removeHeader .fc .fc-button-primary:focus {\n  box-shadow: var(--danger-color) 0px 0px 0px 0.2rem;\n}\n\n.linkText {\n  color: blue;\n  text-decoration: underline;\n}\n\n.danger-underline {\n  color: var(--danger-color);\n  text-decoration: underline;\n}\n\ninput[type=\"checkbox\"] {\n  accent-color: var(--danger-color);\n}\n\n.plusMinus {\n  border: 1px solid;\n  border-radius: 12px;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  cursor: pointer;\n  margin-top: 4px;\n}\n\n.plusMinus:hover {\n  background-color: var(--danger-color);\n  color: #fff;\n  border: none;\n}\n\n.p-dropdown-panel .p-dropdown-item.p-highlight {\n  background-color: var(--danger-color) !important;\n  color: #fff !important;\n}\n\n.p-dropdown .p-dropdown-label {\n  background-color: #fff !important;\n  color: #000 !important;\n}\n.p-dropdown .p-dropdown-label {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.9rem;\n}\n.p-dropdown .p-dropdown-label.p-placeholder {\n  color: #6c757d !important;\n  font-size: 0.9rem;\n}\n\n.inventory-select.form-select {\n  height: 40px;\n  background-color: #fff;\n  border: 1px solid #E9ECEF;\n  border-radius: 6px;\n  color: #212529;\n  font-size: 14px;\n}\n\n.inventory-select.form-select:focus {\n  border-color: #C9194A;\n  box-shadow: 0 0 0 0.2rem rgba(201, 25, 74, 0.15);\n}\n\nul {\n  padding: 0px;\n}\n\n.p-component {\n  font-size: 14px !important;\n}\n\n.text-danger {\n  color: var(--danger-color);\n}\n\n.copyItem {\n  background-color: #fff;\n  color: #000000;\n  padding: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.invoiceTR td {\n  text-align: center;\n}\n\n.invoiceHead {\n  background-color: var(--danger-color);\n  color: #fff;\n  padding: 4px;\n  font-weight: 500;\n}\n\n.invoiceBody {\n  padding: 4px;\n  word-wrap: break-word;\n}\n\n.leftRounded {\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n}\n\n.anchor_link {\n  font-size: 14px;\n  color: var(--danger-color);\n  text-decoration: underline;\n  margin: 0;\n  cursor: pointer;\n}\n\n.profile_bg_color {\n  background: #20202050;\n  min-height: calc(100dvh - 66px);\n}\n\n/* Login page light-mode hero — scoped so ProfileSetup is unaffected */\n.login_hero_bg {\n  background: linear-gradient(135deg, #fce4ec 0%, #fafafa 50%, #ede7f6 100%);\n  position: relative;\n  overflow: hidden;\n  min-height: 100dvh;\n  padding-top: 66px;\n}\n\n.login_hero_bg::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.025) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(0, 0, 0, 0.025) 1px, transparent 1px);\n  background-size: 56px 56px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.login_hero_bg > * {\n  position: relative;\n  z-index: 1;\n}\n\n.login_hero_bg .title_head {\n  font-size: clamp(32px, 4vw, 56px);\n  font-weight: 700;\n  line-height: 1.1;\n  color: #212121;\n  padding-top: 8rem;\n}\n\n.login_hero_bg .title_head .primary-word {\n  color: #c2185b;\n}\n\n.login_hero_bg .title_sub_head {\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 1.75;\n  color: #424242;\n  max-width: 500px;\n}\n\n.left_row {\n  width: 80%;\n}\n\n/* Login hero image. On tablet/desktop the headline sits in the image's empty\n   top-left area; on phones the image is hidden and the text shows as before. */\n.login_hero_img {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .login_hero_bg .login_hero_visual {\n    position: relative;\n    width: min(100%, calc(100dvh - 66px - 40px));\n    aspect-ratio: 1 / 1;\n    container-type: inline-size;\n    /* stop the flex column stretching the box taller than it is wide */\n    align-self: flex-start;\n  }\n\n  .login_hero_bg .login_hero_img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    /* fade the image edges into the page background */\n    -webkit-mask-image: linear-gradient(to right, transparent 0, #000 2.8%, #000 95.5%, transparent 100%),\n      linear-gradient(to bottom, transparent 0, #000 3.5%, #000 92%, transparent 100%);\n    -webkit-mask-composite: source-in;\n    mask-image: linear-gradient(to right, transparent 0, #000 2.8%, #000 95.5%, transparent 100%),\n      linear-gradient(to bottom, transparent 0, #000 3.5%, #000 92%, transparent 100%);\n    mask-composite: intersect;\n  }\n\n  .login_hero_bg .login_hero_visual .title_head {\n    position: absolute;\n    top: 5cqw;\n    left: 5.5cqw;\n    width: 42cqw;\n    margin: 0;\n    padding-top: 0;\n    font-size: 3.9cqw;\n    line-height: 1.12;\n  }\n\n  .login_hero_bg .login_hero_visual .title_sub_head {\n    display: none;\n  }\n}\n\n/* Landscape tablets (iPad Air/Pro 11\"): the 1/3 form column is narrower than\n   the card's minimum width (reCAPTCHA + padding), so it spilled off screen.\n   Give the form more room. */\n@media (min-width: 992px) and (max-width: 1279.98px) and (orientation: landscape) {\n  .row.login_hero_bg > .col-md-8 {\n    flex: 0 0 58%;\n    max-width: 58%;\n  }\n\n  .row.login_hero_bg > .col-md-4 {\n    flex: 0 0 42%;\n    max-width: 42%;\n  }\n\n  /* fit the 304px reCAPTCHA inside the card */\n  .row.login_hero_bg .tab-adjust {\n    width: 100% !important;\n    max-width: 500px !important;\n  }\n\n  .row.login_hero_bg .tab-adjust > .p-5 {\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }\n}\n\n/* Portrait tablets (iPad): side by side would make the image too small to\n   read, so stack image over form, both centred. The higher specificity beats\n   the site-wide tablet rule that widens every col-md-4 to 50%. */\n@media (min-width: 768px) and (orientation: portrait) {\n  .row.login_hero_bg > .col-md-8,\n  .row.login_hero_bg > .col-md-4 {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .login_hero_bg .login_hero_visual {\n    width: min(100%, 50dvh, 640px);\n  }\n\n  .row.login_hero_bg > .col-md-4 {\n    display: flex;\n    justify-content: center;\n    padding-bottom: 32px;\n  }\n\n  .row.login_hero_bg > .col-md-4 > div > .d-flex {\n    justify-content: center;\n    margin-right: 0 !important;\n    padding-top: 8px !important;\n  }\n\n  .row.login_hero_bg .tab-adjust {\n    width: min(500px, 90vw) !important;\n    margin: 0 auto !important;\n  }\n}\n\n.title_head {\n  font-size: 4rem;\n  font-weight: 600;\n  color: #fff;\n  padding-top: 8rem;\n}\n\n.title_sub_head {\n  font-size: 1rem;\n  font-weight: 400;\n  color: #fff;\n}\n\n.flex_center {\n  display: flex;\n  justify-content: center;\n}\n\n.register_form {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  margin: 2rem 2rem 2rem 0;\n}\n\n.register_form input[type=\"text\"],\n.register_form input[type=\"email\"] {\n  width: 100%;\n  padding: 0.1rem;\n}\n\n.register_label {\n  font-size: 1rem;\n}\n@media (max-width: 767.98px) {\n  .profile_bg_color {\n    display: block; /* stack vertically */\n    padding: 1rem; /* gap from edges */\n    width: auto !important;\n  }\n\n  /* Text on top */\n  .profile_bg_color > .col-md-8 {\n    order: 1;\n    width: 100%;\n    max-width: 600px; /* limits width on mobile */\n    margin: 0 auto 1.5rem auto; /* center with spacing */\n    padding-left: 1rem; /* horizontal gap */\n    padding-right: 1rem; /* horizontal gap */\n  }\n\n  /* Card below */\n  .profile_bg_color > .col-md-4 {\n    order: 2;\n    width: 100%;\n    max-width: 400px; /* card width */\n    margin: 0 auto; /* center horizontally */\n    padding-left: 3rem; /* horizontal gap */\n  }\n\n  /* Headings adjustments */\n  .title_head {\n    font-size: 2rem;\n    padding-top: 1rem;\n    text-align: center;\n  }\n\n  .title_sub_head {\n    font-size: 0.9rem;\n    text-align: center;\n  }\n}\n.border-none {\n  border: none !important;\n}\n\n.login_bg {\n  background: #e6e4de;\n  height: calc(100dvh - 66px);\n  padding-top: 5%;\n}\n\n.title_bold {\n  font-size: 2rem;\n  font-weight: 600;\n}\n.mobile-primary {\n  border-radius: 20px;\n  color: var(--background-color) !important;\n  background: var(--danger-color) !important;\n}\n.normal_tab {\n  border-radius: 20px;\n  color: #202020;\n  background: #f4f4f5;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n/* ============================= */\n/* MOBILE VIEW ONLY */\n/* ============================= */\n\n@media (max-width: 767.98px) {\n  html,\n  body {\n    height: auto;\n    overflow-y: auto;\n  }\n\n  .login_bg {\n    height: auto !important;\n    min-height: 100vh;\n    overflow-y: auto;\n  }\n\n  .profile_bg_color {\n    height: auto !important;\n    min-height: 100vh;\n  }\n  .shadow-lg.bg-body.rounded {\n    width: 95% !important;\n    max-width: 380px !important;\n    margin: 20px auto !important;\n  }\n  .background-color-red {\n    display: flex;\n    justify-content: center;\n  }\n  .background-color-red .d-flex {\n    /* padding-top: 0px !important; */\n  }\n\n  .shadow-lg.bg-body.rounded {\n    margin: 5px auto !important;\n  }\n}\n/* Tablet view: between 769px and 1024px */\n/* Tablet view: 769px to 1024px */\n/* Tablet view: 769px to 1024px */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .tab-adjust {\n    width: 80% !important; /* make card slightly smaller than container */\n    max-width: 500px !important; /* limit max width */\n    margin: 0 auto !important; /* center horizontally */\n    box-sizing: border-box; /* include padding in width */\n  }\n\n  .background-color-red {\n    display: flex !important; /* make sure flex works */\n    justify-content: center; /* center the card */\n    padding-top: 10px !important; /* optional vertical spacing */\n  }\n}\n@media (max-width: 767.98px) {\n  .otp-wrapper input {\n    width: 40px !important;\n    height: 50px !important;\n    font-size: 18px !important;\n    /* margin: 0 4px !important; */\n    border-radius: 8px;\n    text-align: center;\n  }\n\n  .otp-wrapper > div {\n    width: 100% !important;\n    justify-content: center !important;\n    /* gap: 6px; */\n  }\n}\n.border_rad_16 {\n  border-radius: 16px;\n}\n.accordion-button:not(.collapsed) {\n  color: #000 !important; /* Text color */\n  background-color: transparent !important; /* Keep background transparent */\n  border: 1px solid #dc3545 !important; /* Your custom border */\n  box-shadow: none !important; /* Remove default blue shadow */\n  outline: none !important; /* Remove focus outline */\n}\n\n/* Collapsed Accordion Header */\n.accordion-button.collapsed {\n  color: #000 !important;\n  background-color: transparent !important;\n  border: 1px solid #dc3545 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Remove Bootstrap default focus outline when clicking */\n.accordion-button:focus {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Recharts wraps every chart (RevenueLineChart, StatusDonutChart, etc.) in\n   a div[tabIndex=0] for keyboard accessibility — clicking inside it (a line\n   point, a pie slice, or just the chart area) focuses that div, and the\n   browser's default focus ring then renders as a black rectangle around\n   the whole chart card. Suppress it the same way the accordion buttons\n   above do. */\n.recharts-wrapper:focus,\n.recharts-wrapper *:focus,\n.recharts-surface:focus {\n  outline: none !important;\n}\n\n/* Today's Schedule / Upcoming Bookings row list (TodaysScheduleList.jsx) —\n   a thin scrollbar so a long, scrolling list doesn't visibly lose row\n   width/padding on the right compared to a short sibling list that never\n   needs to scroll. */\n.dash-schedule-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n.dash-schedule-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n.dash-schedule-scroll::-webkit-scrollbar-thumb {\n  background: #E3EBF8;\n  border-radius: 999px;\n}\n.dash-schedule-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #E3EBF8 transparent;\n}\n\n.p-multiselect-panel .p-multiselect-header {\n  padding: 0.5rem 0.5rem;\n}\n.p-multiselect-items-wrapper ul {\n  padding: 0;\n}\n.addServiceModal {\n  width: 50% !important;\n}\n\n.form-check-input:checked {\n  background-color: var(--danger-color) !important;\n  border-color: var(--danger-color) !important;\n}\n/* CARD 1 – Service selection */\n.service-selection-card {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 20px;\n  border: 1px solid #e6e6e6;\n}\n\n/* Section titles */\n.section-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n/* Service type pills */\n.service-type-pill {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  cursor: pointer;\n  font-weight: 500;\n  transition: 0.2s;\n}\n\n.service-type-pill.active {\n  background: #fff1f2;\n  border: 1.5px solid #dc3545;\n}\n\n/* Offering row card */\n.offering-row-card {\n  background: #fff;\n  border: 1px solid #e6e6e6;\n  border-radius: 12px;\n  padding: 12px 14px;\n  transition: 0.2s ease;\n}\n\n.offering-row-card:hover {\n  border-color: #dc3545;\n}\n\n.price-text {\n  font-size: 12px;\n  color: #dc3545;\n}\n\n/* CARD 2 – Service information */\n.service-summary-card {\n  border: 1px solid #e6e6e6;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.service-summary-header {\n  padding: 12px 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e6e6e6;\n  background: #fafafa;\n  border-radius: 12px 12px 0 0;\n}\n/* ============================= */\n/*  MOBILE RESPONSIVE (ONLY)  */\n/* ============================= */\n\n@media (max-width: 767.98px) {\n  /* Reduce outer spacing */\n  .mt-4.mb-2 {\n    margin-top: 10px !important;\n    margin-bottom: 10px !important;\n  }\n\n  /* Accordion header spacing */\n  .accordion-button {\n    font-size: 15px;\n    padding: 12px 16px;\n  }\n\n  /* Make all bootstrap columns full width */\n  .row > [class*=\"col-\"] {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n  }\n\n  /* Stack form sections nicely */\n  .accordion-body {\n    padding: 16px;\n  }\n\n  /* Customer info spacing */\n  .accordion-body .row {\n    row-gap: 12px;\n  }\n\n  /* Make inputs more touch friendly */\n  .form-control,\n  .p-dropdown,\n  .PhoneInput input {\n    height: 45px !important;\n    font-size: 14px;\n  }\n\n  /* ============================= */\n  /* SERVICE SELECTION CARD       */\n  /* ============================= */\n\n  .service-selection-card {\n    padding: 16px;\n    border-radius: 12px;\n  }\n\n  /* Service pills full width like image */\n  .service-type-pill {\n    width: 100%;\n    text-align: center;\n    padding: 12px;\n  }\n\n  /* Offering grid → single column */\n  .offering-row-card {\n    width: 100%;\n  }\n\n  .offering-row-card .btn {\n    min-width: 70px;\n  }\n\n  /* Remove col-md-3 grid on mobile */\n  .service-selection-card .col-md-3 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  /* ============================= */\n  /* SERVICE SUMMARY CARD         */\n  /* ============================= */\n\n  .service-summary-card {\n    margin-top: 16px;\n  }\n\n  .service-summary-card .row {\n    row-gap: 14px;\n  }\n\n  /* Make date/time/status blocks stacked */\n  .service-summary-card .col-md-3 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  /* Price section mobile refinement */\n  .service-summary-card .border {\n    margin-top: 15px;\n    border-radius: 12px !important;\n  }\n\n  .service-summary-card .border .d-flex {\n    font-size: 14px;\n  }\n\n  /* Make price input smaller */\n  .service-summary-card input {\n    width: 80px !important;\n    height: 35px !important;\n  }\n\n  /* ============================= */\n  /* Submit Button Mobile Style   */\n  /* ============================= */\n\n  .custom-btn.btn-large {\n    width: 100%;\n    height: 48px;\n    font-size: 16px;\n    border-radius: 10px;\n  }\n\n  .d-flex.justify-content-center.mb-0.gap-4 {\n    padding: 0 16px 20px 16px;\n  }\n}\n/* =============================== */\n/* TABLET PORTRAIT (iPad Vertical) */\n/* =============================== */\n@media (min-width: 768px) and (max-width: 991px) {\n  /* Keep 2-column layout instead of full stack */\n  .row > [class*=\"col-md-4\"] {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  /* Reduce spacing */\n  .accordion-body {\n    padding: 20px;\n  }\n\n  /* Service offering grid 2 columns */\n  .service-selection-card .col-md-3 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  /* Price summary spacing */\n  .service-summary-card .row {\n    row-gap: 16px;\n  }\n\n  /* Slightly bigger button */\n  .custom-btn.btn-large {\n    height: 50px;\n  }\n}\n/* ============================= */\n/* MOBILE DASHBOARD FIX */\n/* ============================= */\n/* \n@media (max-width: 767.98px) {\n\n  .responsive-dashboard {\n    padding: 10px !important;\n  }\n\n  .calendar-section {\n    display: none !important;\n  }\n\n  .new-appointment-section {\n    width: 100% !important;\n    padding: 15px !important;\n    border-radius: 16px !important;\n  }\n\n  .responsive-dashboard .mb-3.d-flex.gap-3 {\n    flex-direction: column !important;\n    gap: 12px !important;\n  }\n\n  .label-dropdown-toggle {\n    width: 100% !important;\n  }\n\n  .label-provider-dropdown {\n    width: 100% !important;\n    max-height: 220px !important;\n    overflow-y: auto !important;\n  }\n\n  .responsive-dashboard [style*=\"timeSlotList\"] {\n    position: absolute !important;\n    width: 100% !important;\n    left: 0 !important;\n    z-index: 999 !important;\n  }\n\n  .responsive-dashboard .time-slot-grid {\n    grid-template-columns: repeat(3, 1fr) !important;\n  }\n\n  .responsive-dashboard .btn-large {\n    height: 45px !important;\n    font-size: 14px !important;\n  }\n\n  .appointment-sidebar-popup {\n    width: 100% !important;\n    right: 0 !important;\n    border-radius: 20px 20px 0 0 !important;\n    bottom: 0 !important;\n    top: auto !important;\n    height: 90vh !important;\n  }\n\n  .appointment-sidebar-overlay {\n    background: rgba(0,0,0,0.4) !important;\n  }\n\n} */\n\n/* Desktop */\n\n/* .sidebar-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1049;\n} */\n\n/* @media (min-width: 768px) {\n  .sidebar-overlay {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .sidebar .nav-link {\n    padding: 12px 16px !important;\n    font-size: 15px;\n  }\n\n  .sidebar .form-labels {\n    font-size: 14px;\n  }\n} */\n.p-multiselect {\n  width: 90% !important;\n  min-width: 0 !important;\n}\n\n.p-multiselect-label {\n  padding-right: 0 !important;\n}\n/* Mobile Responsive Styles */\n@media (max-width: 767.98px) {\n  .container-fluid {\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    background-color: #f8f9fa;\n  }\n\n  .overview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  .overview-header h5 {\n    font-size: 16px !important;\n    margin: 0 !important;\n  }\n\n  .filter-by-section {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .filter-by-text {\n    font-size: 12px !important;\n  }\n\n  .overview-tiles-row {\n    margin: 0 !important;\n    padding: 0 16px;\n    gap: 12px !important;\n  }\n\n  .overview-tiles-row .col-6 {\n    padding: 0 !important;\n  }\n\n  .overview-tiles-row .card {\n    height: 100px !important;\n    padding: 12px !important;\n    border-radius: 8px !important;\n  }\n\n  .schedule-section {\n    margin-top: 20px;\n    background-color: #fff;\n  }\n\n  .schedule-title {\n    padding: 12px 16px;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 0 !important;\n  }\n\n  .schedule-search {\n    padding: 0 16px 12px;\n  }\n\n  .schedule-search input {\n    width: 100% !important;\n    height: 36px !important;\n    font-size: 13px !important;\n    background-color: #f8f9fa;\n    border: 1px solid #e3ebf8 !important;\n    padding-left: 32px !important;\n  }\n\n  .date-selector-mobile {\n    display: flex;\n    overflow-x: auto;\n    gap: 8px;\n    padding: 12px 16px;\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .date-btn {\n    min-width: 50px;\n    padding: 8px 6px !important;\n    border-radius: 6px !important;\n    border: 1px solid #e3ebf8 !important;\n    background-color: #fff !important;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    flex-shrink: 0;\n  }\n\n  .date-btn.active {\n    border: 2px solid #c9194a !important;\n    background-color: #fff7f9 !important;\n  }\n\n  .appointment-card-item {\n    padding: 12px 16px;\n    border-bottom: 1px solid #e3ebf8;\n    display: flex;\n    gap: 12px;\n    cursor: pointer;\n  }\n\n  .appointment-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    flex-shrink: 0;\n    background-color: #e3ebf8;\n  }\n\n  .appointment-info {\n    flex: 1;\n  }\n\n  .appointment-name {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  .appointment-specialty {\n    margin: 0;\n    font-size: 12px;\n    color: #6c757d;\n  }\n\n  .appointment-time {\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n    margin-left: auto;\n  }\n\n  .d-lg-none {\n    display: block !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .overview-header {\n    padding: 10px 12px;\n  }\n\n  .schedule-title {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .date-btn {\n    min-width: 45px;\n  }\n}\n/* ============================= */\n/* MOBILE ONLY CHANGES */\n/* ============================= */\n/* @media (max-width: 767px) {\n\n  .crew-top-section > .col-md-4 {\n    width: 50%;\n  }\n\n  .crew-top-section > .col {\n    width: 50%;\n  }\n\n  .crew-top-section .form-label {\n    display: none !important;\n  }\n\n  .crew-top-section .add-btn-wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 12px;\n  }\n   .crew-top-section .col-6 > div {\n    width: 100%;\n  }\n\n  .crew-top-section .p-multiselect {\n    width: 100% !important;\n  }\n\n} */\n@media (max-width: 767.98px) {\n  .mobile-filters {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 8px !important;\n  }\n\n  /* Force ALL children equal width */\n  .mobile-filters > * {\n    flex: 0 0 calc(50% - 4px) !important;\n    max-width: calc(50% - 4px) !important;\n  }\n\n  /*  IMPORTANT FIX FOR SELECT DATE */\n  .mobile-filters > div:first-child {\n    width: 100%;\n  }\n\n  .mobile-filters > div:first-child .d-flex.position-relative {\n    width: 100%;\n  }\n\n  .mobile-filters > div:first-child button {\n    width: 100% !important;\n  }\n\n  /* PrimeReact fix */\n  .mobile-filters .p-multiselect {\n    width: 100% !important;\n    min-width: 0 !important;\n  }\n\n  /* Clear All alignment */\n  .mobile-filters .danger-underline {\n    display: flex;\n    align-items: center;\n    height: 40px;\n    margin-top: 22px;\n  }\n  .mobile-filters > * {\n    flex: 0 0 calc(50% - 4px) !important;\n    max-width: calc(50% - 4px) !important;\n  }\n\n  /* THIS FIXES SELECT DATE */\n  .mobile-filters .position-relative {\n    width: 100% !important;\n  }\n\n  .mobile-filters .position-relative .flex-column {\n    width: 100% !important;\n  }\n\n  .mobile-filters button {\n    width: 100% !important;\n    justify-content: space-between;\n  }\n\n  /* PrimeReact fix */\n  .mobile-filters .p-multiselect {\n    width: 100% !important;\n    min-width: 0 !important;\n  }\n\n  /* ACTION BUTTONS */\n  .mobile-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .mobile-actions button {\n    flex: 0 0 calc(50% - 4px);\n    max-width: calc(50% - 4px);\n  }\n}\n\n.clearAll {\n  color: var(--danger-color) !important;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.flex-center-col {\n  display: flex;\n  justify-self: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.flex-center {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n.setupBox {\n  background: #fff;\n  color: #000;\n  border-radius: 16px;\n  padding: 2rem;\n}\n\n.justify-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.align-center {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.eachSetup {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem;\n  border: 1px solid #0000001f;\n  border-radius: 10px;\n  margin-bottom: 0.75rem;\n  cursor: pointer;\n}\n\n.rightArrow {\n  padding: 6px 10px;\n  border-radius: 32px;\n  background: var(--danger-color);\n  color: #fff;\n}\n\n.completedBOX {\n  background-color: #f2fff4;\n}\n.greenTick {\n  width: 36px;\n  height: 36px;\n}\n/* Prevent horizontal scroll in mobile */\n/* @media (max-width: 767.98px) {\n  html, body {\n    overflow-x: hidden;\n  }\n} */\n@media (max-width: 767.98px) {\n  .modal-dialog {\n    margin: 10px !important;\n  }\n\n  .modal-content {\n    width: 100% !important;\n  }\n  .service-page-wrapper select {\n    width: 100% !important;\n    margin-top: 10px;\n  }\n\n  .service-page-wrapper .form-select {\n    max-width: 100%;\n  }\n  .table-responsive {\n    overflow-x: auto;\n  }\n  .mobile-action-buttons {\n    width: 100%;\n    margin-top: 10px;\n  }\n\n  .mobile-action-buttons > div {\n    flex: 1 1 100%;\n    text-align: center;\n  }\n  .service-page-wrapper {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  /* Filter row wrap properly */\n  .service-page-wrapper .d-flex {\n    flex-wrap: wrap !important;\n  }\n\n  /* MultiSelect full width on mobile */\n  .service-page-wrapper .p-multiselect {\n    width: 100% !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .filters-mobile {\n    width: 100%;\n  }\n\n  /* FORCE exactly 2 items per row */\n  .filters-mobile > * {\n    flex: 0 0 48% !important;\n    max-width: 48% !important;\n  }\n\n  .filters-mobile .p-multiselect {\n    width: 100% !important;\n    min-width: 0 !important;\n  }\n\n  /* Buttons full row */\n  .actions-mobile {\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  /* 2 buttons in one row */\n  .actions-mobile > div {\n    flex: 0 0 calc(50% - 8px);\n    text-align: center;\n  }\n}\n@media (max-width: 767.98px) {\n  .pagination-wrapper {\n    /* overflow-x: auto; */\n    width: 100%;\n  }\n\n  .pagination-wrapper > div {\n    min-width: max-content;\n  }\n}\n@media (max-width: 767.98px) {\n  body {\n    overflow-x: hidden;\n  }\n\n  .container-fluid {\n    overflow-x: hidden;\n  }\n}\n@media (max-width: 767.98px) {\n  .header-mobile-fix {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 14px;\n  }\n\n  /* Search full width */\n  .header-mobile-fix > .col-md-4 {\n    width: 100% !important;\n    flex: 0 0 100% !important;\n  }\n\n  /* Hide Filter text */\n  .header-mobile-fix .form-label {\n    display: none !important;\n  }\n\n  /* Filter row */\n  .header-mobile-fix > .col.d-flex {\n    width: 100% !important;\n    display: flex !important;\n    align-items: center;\n    gap: 10px;\n  }\n\n  /* Dropdown expands */\n  .header-mobile-fix > .col.d-flex > div {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .header-mobile-fix .p-multiselect {\n    width: 100% !important;\n  }\n\n  /*  PUSH ADD BUTTON TO RIGHT */\n  .header-mobile-fix > button {\n    align-self: flex-end; /* THIS moves it to right */\n    height: 40px;\n  }\n}\n/* ---------------- MOBILE VIEW ONLY ---------------- */\n@media (max-width: 767px) {\n  .mobile-btn-row {\n    flex-wrap: nowrap !important;\n    gap: 6px;\n  }\n\n  .mobile-btn-row {\n    flex: 1;\n    /* padding: 6px 8px !important; */\n    font-size: 12px;\n    line-height: 1;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Dropdown grid: 2 per row */\n  .mobile-dropdown-grid {\n    flex-wrap: wrap;\n    width: 100% !important;\n  }\n\n  .mobile-dropdown-grid > * {\n    width: 46% !important;\n  }\n\n  .mobile-dropdown-grid > *:nth-child(odd) {\n    margin-right: 4%;\n  }\n}\n\n.opacityBOX {\n  opacity: 0.5;\n}\n.opacityFull {\n  opacity: 1 !important;\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover,\n.dropdown-item:focus-visible {\n  background-color: var(--danger-color) !important;\n  color: #fff !important;\n}\n\n.viewBtn {\n  border-radius: 16px;\n  border: 1px solid var(--danger-color) !important;\n}\n.viewBtn .p-multiselect-label,\n.viewBtn .p-multiselect-trigger {\n  color: var(--danger-color);\n}\n.border-radius-16px {\n  border-radius: 16px !important;\n}\n.otp-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.otp-popup-card {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  width: 350px;\n  text-align: center;\n}\n\n.tableHeader {\n  background-color: var(--borders-color) !important;\n  padding: 0.4rem;\n  font-weight: 700;\n}\n\n.borderX {\n  border-left: 1px solid #20202050;\n  border-right: 1px solid #20202050;\n}\n\n.rightClick {\n  margin-left: -1.5rem;\n  cursor: pointer;\n}\n/* Phone input field */\n.react-tel-input .form-control {\n  border: 1px solid #ced4da !important;\n  height: 38px;\n  border-radius: 6px;\n}\n\n/* Email input field */\n.form-control {\n  border: 1px solid #ced4da !important;\n  height: 38px;\n  border-radius: 6px;\n}\n\n/* Focus state for both */\n.react-tel-input .form-control:focus,\n.form-control:focus {\n  box-shadow: none !important;\n}\n.consent-text {\n  font-size: 12px;\n  color: #6b7280; /* soft gray */\n  margin-top: 16px;\n  line-height: 1.5;\n  width: 100%;\n}\n\n.link-text {\n  color: #1d4ed8; /* your primary blue */\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.link-text:hover {\n  text-decoration: underline;\n}\n\n.setup-container {\n  display: flex;\n  justify-content: center;\n}\n\n.inner-setup-container {\n  width: 50%; /* desktop default */\n  max-width: 600px;\n}\n\n/* Mobile-specific styles */\n@media (max-width: 767.98px) {\n  .inner-setup-container {\n    width: 100%;\n    padding: 0.5rem;\n  }\n\n  .setupBox .eachSetup {\n    flex-direction: row !important; /* keep number + text + tick in one row */\n    align-items: center !important;\n    justify-content: space-between;\n    padding: 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .setupBox .eachSetup .flex-col {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem; /* title above description */\n  }\n\n  .setupBox .eachSetup img.greenTick {\n    width: 32px;\n    height: 32px;\n  }\n\n  .setupBox .progress-label {\n    font-size: 10px;\n    padding: 4px;\n  }\n}\n\n.w-45 {\n  width: 45%;\n}\n.bgWhite {\n  background: #fff;\n}\n.calendarMessage {\n  padding: 2rem;\n  color: var(--danger-color);\n}\n\n.closeCalender {\n  display: flex;\n  justify-content: end;\n  padding: 2px 8px;\n  cursor: pointer;\n  position: absolute;\n  right: 0px;\n  color: #202020;\n  border: 1px solid black;\n  border-radius: 16px;\n}\n\n.bookingCalender .fc-header-toolbar {\n  position: absolute;\n  /* top: 11rem; */\n  width: 66rem;\n}\n\n.bookingCalender .fc .fc-view-harness {\n  margin-top: 3rem;\n  height: 80dvh;\n  overflow: scroll;\n}\n\n.submitcalendar {\n  display: flex;\n  justify-content: end;\n  margin-top: 1rem;\n  cursor: pointer;\n}\n\n.fadeBtn {\n  opacity: 0.5;\n}\n.img-preview {\n  width: 80px;\n  height: 80px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.remove-btn {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: red;\n  color: #fff;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  font-size: 12px;\n  text-align: center;\n  cursor: pointer;\n  line-height: 18px;\n}\n\n.calendarData {\n  display: none;\n}\n\n.hoverCalendarBox:hover .calendarData {\n  display: block;\n}\n@media (max-width: 767.98px) {\n  .mobile-top-actions {\n    display: flex;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .mobile-top-actions > * {\n    width: 50% !important; /* 🔥 each takes half */\n  }\n\n  /* Fix dropdown width */\n  .mobile-top-actions .viewBtn,\n  .mobile-top-actions .p-multiselect,\n  .mobile-top-actions .dropdown,\n  .mobile-top-actions .dropdown-toggle {\n    width: 100% !important;\n  }\n\n  /* Prevent overflow */\n  .mobile-top-actions .dropdown-toggle {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n@media (max-width: 767.98px) {\n  .mobile-admin-view {\n    flex-direction: column !important;\n    gap: 15px;\n  }\n\n  .mobile-card {\n    width: 100% !important;\n  }\n\n  .mobile-card .tableHeader {\n    font-size: 14px;\n    padding: 10px !important;\n  }\n\n  /* Row styling (EachRowCell improvement) */\n  .mobile-card .row-cell {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n    font-size: 13px;\n  }\n\n}\n@media (max-width: 767.98px) {\n\n  .mobile-admin-view {\n    flex-direction: column !important;\n    gap: 15px;\n  }\n\n  .mobile-card {\n    width: 100% !important;\n    background: #fff;\n    border-radius: 10px;\n    border: 1px solid #eee;\n    overflow: hidden;\n  }\n\n  .mobile-card .tableHeader {\n    font-size: 14px;\n    padding: 10px !important;\n    background: #f8f9fa;\n  }\n}\n/* Mobile */\n@media (max-width: 767.98px) {\n  .footer-item {\n    width: 48%;\n    font-size: 12px;\n  }\n}\n.company-footer {\n  background: #d01c4c;\n  color: #fff;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 14px 18px;\n  border-radius: 8px;\n  gap: 12px;\n}\n\n/*  KEY CHANGE */\n.footer-item {\n  flex: 1; /* auto take equal width */\n  min-width: 200px; /* prevents too small items */\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n}\n\n/* Icon circle */\n.footer-icon {\n  background: rgba(255, 255, 255, 0.15);\n  padding: 8px;\n  border-radius: 50%;\n  font-size: 14px;\n  min-width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.open-link-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 16px;\n  color: #007aff;\n}\n\n.open-link-icon:hover {\n  color: #0d6efd;\n}\n.btn-custom-danger {\n  background-color: #dc3545;\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n\n  width: auto; /*  important */\n  display: inline-block; /*  important */\n}\n.percent-symbol {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n}\n\n.flexCenter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.react-datepicker__day--selected-single {\n  background-color: #216ba5 !important;\n  color: white !important;\n  border-radius: 50% !important;\n}\n.react-datepicker__day--highlighted-booking {\n  background-color: #d01c4c !important;\n  color: black !important;\n  border-radius: 50%;\n}\n.p-multiselect .p-multiselect-clear-icon {\n  display: none !important;\n}\n\n.p-multiselect-filter-container .p-input-icon-right {\n  display: none !important;\n}\n.custom-multiselect-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* MultiSelect main box */\n.custom-multiselect {\n  width: 100%;\n  height: 40px;\n}\n\n/* give space for icon inside */\n.custom-multiselect .p-multiselect-label {\n  padding-right: 30px !important;\n}\n\n/* ✅ clear icon INSIDE field */\n.clear-selected-icon {\n  position: absolute;\n  right: 30px; /* adjust inside field */\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 14px;\n  color: #888;\n  z-index: 2;\n}\n\n/* ===== FILTER INPUT ===== */\n\n.custom-filter {\n  position: relative;\n  padding: 5px;\n}\n\n.custom-filter input {\n  width: 100%;\n  height: 35px;\n  padding: 0 30px 0 10px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  outline: none;\n}\n\n/* clear inside search */\n.custom-filter .clear-icon {\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 14px;\n  color: #888;\n}\n@media (max-width: 767.98px) {\n  .react-datepicker__navigation {\n    pointer-events: auto !important;\n    z-index: 9999;\n    width: 40px;\n    height: 40px;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 10px !important;\n    pointer-events: auto !important;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 10px !important;\n    pointer-events: auto !important;\n  }\n  .react-datepicker {\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .react-datepicker__navigation-icon::before {\n    border-width: 2px 2px 0 0 !important;\n  }\n}\n/* ONLY MOBILE VIEW */\n@media (max-width: 767.98px) {\n  .mobile-crew-view .crew-card {\n    background: #fff;\n    border-radius: 14px;\n    padding: 14px;\n    margin-bottom: 12px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  }\n\n  .mobile-crew-view .crew-title {\n    font-size: 13px;\n    color: #6c757d;\n    margin-top: 2px;\n  }\n\n  .mobile-crew-view .job-item {\n    padding: 6px 0;\n    cursor: pointer;\n  }\n\n  .mobile-crew-view .slot-pill {\n    background: #eef5ff;\n    padding: 6px 10px;\n    border-radius: 20px;\n    font-size: 12px;\n  }\n  .mobile-crew-view .slots-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    max-height: 40px;\n    overflow: hidden;\n    transition: all 0.3s ease;\n  }\n\n  .mobile-crew-view .slots-container.expanded {\n    max-height: 120px;\n    overflow-y: auto;\n  }\n\n  .mobile-crew-view .more-btn {\n    background: #dbeafe;\n    cursor: pointer;\n    font-weight: 500;\n  }\n  .mobile-crew-view .slot-pill.available {\n    background: #eef5ff;\n    color: #037fe8;\n  }\n\n  .mobile-crew-view .slot-pill.booked {\n    background: #fdeaea;\n    color: #e53935;\n    text-decoration: line-through;\n  }\n  .job-category-inline {\n    font-size: 11px;\n    background: #eef5ff;\n    color: #dc3545;\n    padding: 2px 8px;\n    border-radius: 12px;\n    white-space: nowrap;\n  }\n}\n.mobile-calendar-nav {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.mobile-calendar-nav button {\n  border: none;\n  background: #f5f7fa;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 16px;\n}\n.p-multiselect-panel {\n  z-index: 999999 !important;\n}\n.p-dropdown-panel {\n  z-index: 999999 !important;\n}\n.onboarding-wrapper {\n  min-height: 100vh;\n  background: #f5f7fb;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 80px;\n}\n\n/* CARD */\n.onboarding-card {\n  width: 100%;\n  max-width: 700px;\n  background: #fff;\n  padding: 30px;\n  border-radius: 8px;\n}\n\n/* TITLE */\n.title {\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.subtitle {\n  color: #6c757d;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n/* OPTIONS */\n.options-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* EACH OPTION */\n.option-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 18px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: #fafafa;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n/* ACTIVE STATE (RED BORDER LIKE IMAGE) */\n.option-box.active {\n  border: 2px solid #dc3545;\n  background: #fff5f5;\n}\n\n/* CHECKBOX */\n.checkbox {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #bbb;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n/* CHECKED */\n.checkbox.checked {\n  background: #dc3545;\n  color: #fff;\n  border: none;\n}\n\n/* BUTTON */\n.submit-btn {\n  margin-top: 20px;\n  padding: 6px 18px;\n  font-size: 14px;\n  border-radius: 20px;\n}\n.custom-offcanvas {\n  width: 400px !important;\n  margin: 20px;\n  border-radius: 8px;\n  height: calc(100% - 40px);\n}\n\n.custom-offcanvas .offcanvas-content {\n  /* border-radius: 16px; */\n  overflow: hidden;\n}\n.appointment-card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.appointment-header {\n  background: \"#ccc\";\n  color: white;\n  font-weight: 600;\n  padding: 12px 16px;\n  font-size: 16px;\n}\n\n.appointment-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px;\n  background: \"#ccc\";\n}\n.appointment-body .form-control,\n.appointment-body .form-select {\n  border-radius: 8px;\n  border: none;\n  font-size: 13px;\n  height: 36px;\n}\n\n/* The global \".form-control { line-height:100% !important; height:40px\n   !important; }\" rule above (line ~101) also matches react-phone-input-2's\n   own input (it carries the \"form-control\" class) and squeezes its line-box\n   down from the library's own line-height:25px to line-height:100% (=14px,\n   since font-size is forced to 14px too) inside a taller 40px box — the\n   \"+91\" prefix text ends up rendered outside the visible line-box and\n   disappears, while the flag icon (a separate, independently-positioned\n   element) is unaffected. That rule uses !important, so only another\n   !important rule with equal-or-higher specificity can win here. */\n.appointment-body .react-tel-input .form-control {\n  height: 40px !important;\n  line-height: 40px !important;\n  padding-left: 48px !important;\n}\n\n.appointment-body label {\n  font-size: 12px;\n  margin-bottom: 4px;\n  color: #000 !important;\n}\n.p-multiselect {\n  width: 100% !important;\n}\n.blocked-date {\n  background-color: #ffe5e5 !important;\n  color: #d32f2f !important;\n  border-radius: 50%;\n  /* text-decoration: line-through; */\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
